import React, { useEffect, useRef, useState } from "react";
import star_logo from "../../assets/star_logo.png";
import IconCollection from "../../IconCollection/IconCollection";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider } from "react-dnd";
import "./ControlPage.css";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import "react-rangeslider/lib/index.css";
import Starter from "./Starter";
import basketballFieldImg from "../../assets/basketball-field.png";
import { baseApi } from "../../urlConfig";
import CustomDropdownControlPage from "../../Component/CustomDropdown/CustomDropdownControlPage";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { startNewTimer, startTimer, stopNewTimer, stopTimer } from "../../redux/actions/timerService";
import { createScoreData, determineScoreType, handleAddNewScoreBulk, handleAddNewScoreReBulk, handleNavigateStreamingOverlays, handlePointSelect, handleScoreDelete, handleScoreTemporaryData, handleTeamOnePlayingPlayerTimeSend, handleTeamOnePlayingPlayerTimeSend2, handleTeamPlayingPlayerTimeSend, sendTimerData } from "../../redux/actions/playerAction";
import { useMutation } from "react-query";
import Timer from '../../Component/Timer/Timer';
import Loading from '../../Component/Loading/Loading';
import { addNewScore } from '../../lib/apiService';
import IsPortraitModal from './IsPortraitModal';
import ScoreDeleteModal from './ScoreDeleteModal';
import ResetDataModal from './ResetDataModal';
import FoulActionsSelections from './FoulActionsSelections';
import TurnoverSelections from './TurnoverSelections';
import AssistSelections from './AssistSelections';
import ReboundSelections from './ReboundSelections';
import ShortFieldSelections from './ShortFieldSelections';
import PlayerControlSelections from './PlayerControlSelections';
import ShortSelections from './ShortSelections';
import GameLogComponent from './GameLogComponent';
import LogStatusActions from './LogStatusActions';
import GameLogEntry from './GameLogEntry';
import ExpendPanel from './ExpendPanel';
import MatchComponent from './MatchComponent';
import HeaderComponent from './HeaderComponent';
import { deletePostingData, gameData, matchStatusUpdate, playerAssistSection, playerAssistSelection, playerSelectionTeamOne, playerSelectionTeamOneMiss, playerSelectionTeamTwo, playerSelectionTeamTwoMiss, resetJumpBallPlayers, resetScoreTemporaryData, selectedQuarter, setJumpBallTeamAPlayerRosterId, setJumpBallTeamBPlayerRosterId, setOpenStarterModal, setQuarterOptions, shortFieldSelection, submitPlayersAndMatchData, teamOneColorSet, teamTwoColorSet, togglePossessionArrowTeamOne, togglePossessionArrowTeamTwo, toggleTimeout, updateAllPostingDataStatusFailed, updateMatchTeamOneRoster, updateMatchTeamTwoRoster, updateMatchTimeStatus, updatePostingDataReset, updateSLNo, updateSLNoPayload, updateUndoStep, updateEventType } from '../../redux/reducers/playersReducer';
import { fiveXFiveDefaultPeriod, fiveXFiveOvertimePeriod, resetTimer, setIsRunning, setMinutes, setSeconds, toggleFoul, toggleGoalAnytimeDuringOvertime, toggleGoalWithinLast2Minutes, toggleOutOfBounds, toggleShotClockCheck, toggleShotClockViolation, topTimerWhenFoulCalled } from '../../redux/reducers/settingReducer';
import ShotClock from './ShotClock';
import JumpBallModal from './JumpBallModal';
import { startJumpBallClock, stopJumpBallClock } from '../../redux/actions/JumpBallClockService';
import { IoSettingsOutline } from 'react-icons/io5';
import Settings from '../Settings/Settings';
import ResetTimerModal from './ResetTimerModal';
import ErrorPage from '../../Component/Error/Error';
import { Helmet } from 'react-helmet';
import ConfirmHardReload from './ConfirmHardReload';

const ControlPage = () => {
  const {
    playerPointSelect,
    made1PT,
    made2PT,
    made3PT,
    miss1PT,
    miss2PT,
    miss3PT,
    toPT,
    foul,
    foulActions,
    toActions,
    shortSelections,
    shortFieldSelections,
    playerControlSelections,
    assistSelections,
    reboundSelections,
    turnoverSelections,
    actionPlayerId,
    playerSelectionsTeamOne,
    playerSelectionsTeamTwo,
    foulActionsSelections,
    madePT,
    missPT,
    foulPT,
    actionSteps,
    point1,
    point2,
    point3,
    pointMiss1,
    pointMiss2,
    pointMiss3,
    assistPoint,
    reboundBlockPoint,
    turnoverPoint,
    foulPoint,
    quarter,
    teamOneColor,
    teamTwoColor,
    matchStatus,
    postingData,
    scoreTemporaryData,
    cancelStep,
    sl_no,
    scoreDeleteLoading,
    undoStep,
    shotClock,
    shotClockValue,
    timeout,
    possessionArrowTeamOne,
    possessionArrowTeamTwo,
    openStarterModal
  } = useSelector((state) => state?.playersReducer);

  const { minutes, seconds, isRunning, General, newIsRunning, } = useSelector(
    (state) => state?.settingReducer
  );

  const { shotClockOptions } = General || {};
  const { shotClockCheck, shotClockViolation, foul: foulCheck, timeout: timeoutCheck, outOfBounds, goalWithinLast2Minutes, goalAnytimeDuringOvertime } = shotClockOptions || {};


  const playersReducer = useSelector((state) => state?.playersReducer);
  const quarterOptions = useSelector(
    (state) => state?.playersReducer?.quarterOptions
  );



  const foulCalledSetting = useSelector(
    (state) => state?.settingReducer?.General?.topTimerWhenFoulCalled
  );
  const eventType = useSelector(
    (state) => state?.playersReducer?.eventType
  );
  const jumpBallTeamAPlayerRosterId = useSelector(
    (state) => state?.playersReducer?.jumpBallTeamAPlayerRosterId
  );
  const jumpBallTeamBPlayerRosterId = useSelector(
    (state) => state?.playersReducer?.jumpBallTeamBPlayerRosterId
  );
  const eventType5x5DefaultTimer = useSelector(
    (state) => state?.settingReducer?.General?.fiveXFive?.defaultTimerPerPeriod
  );
  const eventType5x5OvertimeTimer = useSelector(
    (state) =>
      state?.settingReducer?.General?.fiveXFive?.defaultTimerPerOvertime
  );

  const eventType3x3DefaultTimer = useSelector(
    (state) =>
      state?.settingReducer?.General?.threeXThree?.defaultTimerPerPeriod
  );
  const eventType3x3OvertimeTimer = useSelector(
    (state) =>
      state?.settingReducer?.General?.threeXThree?.defaultTimerPerOvertime
  );
  const staticMode = useSelector(
    (state) => state?.settingReducer?.ScoringDialogs?.staticMode
  );

  const settingsReducer = useSelector((state) => state?.settingReducer);
  const selectionAfterFieldGoalAttempt =
    settingsReducer?.ScoringDialogs?.selectionAfterFieldGoalAttempt;
  const showShotChart = settingsReducer?.ScoringDialogs?.showShotChart;
  const matchData = useSelector(
    (state) => state?.playersReducer?.matchData
  );
  const game_data = useSelector(
    (state) => state?.playersReducer?.matchData?.game_data
  );

  const game_subs = useSelector(
    (state) => state?.playersReducer?.matchData?.game_subs
  );
  const [isPortrait, setIsPortrait] = useState(false);
  const [teamAssistSections, setTeamAssistSections] = useState("Assist");
  const [teamTab, setTeamTab] = useState("team1");
  const [teamOneColorSection, setTeamOneColorSection] = useState(false);
  const [fieldLocation, setFieldLocation] = useState({ x: 0, y: 0 });
  const [teamTwoColorSection, setTeamTwoColorSection] = useState(false);
  const [shortSelectionsState, setShortSelectionsState] = useState();
  const [starState, setStarState] = useState(false);
  const [isTimeAuto, setIsTimeAuto] = useState(false);
  const [isTimeAuto2, setIsTimeAuto2] = useState(false);
  const [time, setTime] = useState(0);
  const [time2, setTime2] = useState(0);
  const [time3, setTime3] = useState(0);
  const [scoreDeleteModal, setScoreDeleteModal] = useState(false);
  const [scoreId, setScoreId] = useState(null);
  const [resetDataModal, setResetDataModal] = useState(false);
  const [miss1PTActive, setMiss1PTActive] = useState(false);
  const [teamOnePlayersPlaying, setTeamOnePlayersPlaying] = useState([]);
  const [teamTwoPlayersPlaying, setTeamTwoPlayersPlaying] = useState([]);
  const [postingError, setPostingError] = useState(false);
  const [teamAPlayingCount, setTeamAPlayingCount] = useState(0);
  const [teamBPlayingCount, setTeamBPlayingCount] = useState(0);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [teamTurnoverSections, setTeamTurnoverSections] = useState("Steal");
  const [teamFoulSections, setTeamFoulSections] = useState("PF");
  const [teamReboundSections, setTeamReboundSections] = useState("Rebound");
  const [hideBlock, setHideBlock] = useState(false);
  const [rangeValue, setRangeValue] = useState(50);
  const [rangesliderState, setRangesliderState] = useState(false);
  const [customLoading, setCustomLoading] = useState(true)
  const [expendPanel, setExpendPanel] = useState(false);
  const [selectedValue, setSelectedValue] = useState();
  const [selectedOption, setSelectedOption] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isLoadingOne, setIsLoadingOne] = useState(false);
  const [isLoadingTwo, setIsLoadingTwo] = useState(false);
  const [openJumpBallModal, setOpenJumpBallModal] = useState(false);
  const [resetTimerModal, setResetTimerModal] = useState(false);
  const [setting, setSetting] = useState(false);
  const [autoTo, setAutoTo] = useState(false);
  const [confirmHardReload, setConfirmHardReload] = useState(false);
  const queryParams = new URLSearchParams(window.location.search);
  const eid = queryParams.get('eid');

  const handleHardReload = () => {
    window.location.reload();
  }

  const [loading, setLoading] = useState(false)
  // const [errorMessage, setErrorMessage] = useState(false)
  async function getEventData(token) {
    try {
      const apiUrl = `${process.env.REACT_APP_API_ROOT}/api/get_event/${eid}/`;
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data == null) {
        // setErrorMessage(true)

      } else {
        return response.data;
      }

    } catch (error) {
      // setErrorMessage(true)
      console.error("Error:", error);
      throw error; // Re-throw the error to handle it elsewhere if needed
    }
  }
  const getPeriodList = async () => {

    if(matchData?.team_a_event_type_id || matchData?.team_b_event_type_id){

   

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_ROOT}` + '/api/get_period_list/2900/', {
        headers: {
          'Authorization': `${token}`
        }
      });

      // Normalize API key (handles backend typo) and filter based on event type
      const responseData = response.data?.peiods || response.data?.periods || [];
      const normalizedData = Array.isArray(responseData) ? responseData : [];
      const derivedEventTypeId = matchData?.team_a_event_type_id ? matchData?.team_a_event_type_id : matchData?.team_b_event_type_id;
      const filteredData = derivedEventTypeId === 9
        ? normalizedData.filter((p) => ["NotStarted", "Q1", "Overtime", "Final"].includes(p))
        : normalizedData;

      const transformedData = filteredData.map((period) => ({
        value: period,
        label: period
      }));

      return transformedData;
    } catch (error) {
      console.error('Error:', error);
      throw error; // Rethrow the error to handle it in the parent component
    }
  }
  };
  const fetchSettings = async () => {
    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_API_ROOT}/api/get_Setting/`;
      const formData = new FormData();
      formData.append("e_id", eid);
      const response = await fetch(url, {
        method: 'post',
        headers: {
          'X-TOKEN': `${token}`
        },
        body: formData
      });
      const responseData = await response.json();
      setSetting(responseData);

    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };
  useEffect(() => {
    const handleOrientationChange = () => {
      setIsPortrait(window.orientation === 0 || window.orientation === 180);
    };

    handleOrientationChange();

    window.addEventListener("orientationchange", handleOrientationChange);

    return () => {
      window.removeEventListener("orientationchange", handleOrientationChange);
    };
  }, []);

  const token = window.localStorage.getItem("token");
  const user_data = JSON.parse(window.localStorage.getItem("user_data"));
  const user_id = user_data?.id;
  const dispatch = useDispatch();
  const currentPeriod = matchData?.game_status?.period.trim();
  const currentMatchStatus = matchData?.game_status?.status.trim();
  const team_a_rosters = matchData?.team_a_rosters
  const team_b_rosters = matchData?.team_b_rosters
  const handleTick = () => {
    const updatedTeamAPlayers = team_a_rosters.map((player) =>
      player.is_Playing ? { ...player, play_sec: player.play_sec + 1 } : player
    );
    const updatedTeamBPlayers = team_b_rosters.map((player) =>
      player.is_Playing ? { ...player, play_sec: player.play_sec + 1 } : player
    );

    dispatch(updateMatchTeamOneRoster(updatedTeamAPlayers));

    dispatch(updateMatchTeamTwoRoster(updatedTeamBPlayers));
  };

  useEffect(() => {
    if (newIsRunning) {
      handleTick();
    }
  }, [seconds]);

  useEffect(() => {
    let timer;


    return () => {
      clearInterval(timer);
    };
  }, [newIsRunning, time, team_a_rosters, team_b_rosters]);
  useEffect(() => {
    let timer2;
    timer2 = setInterval(() => {
      setIsTimeAuto((prevTime) => prevTime + 1)
    }, 1000);
    return () => {
      clearInterval(timer2);
    };
  }, [time2])

  useEffect(() => {
    let timer3;
    timer3 = setInterval(() => {
      setIsTimeAuto2((prevTime) => prevTime + 1)
    }, 1000);
    return () => {
      clearInterval(timer3);
    };
  }, [time3])

  useEffect(() => {
    localStorage.setItem("event_id", '');
    localStorage.setItem("eventID", '')
    if (matchData && matchData?.game_status) {

      const scoreList = matchData?.game_data?.scoreList || [];
      const maxSlNo = scoreList.reduce((max, score) => Math.max(max, score.sl_no), 0);
      const currentTime = (matchData?.game_status?.time == 0 && !currentPeriod) ? (eventType5x5DefaultTimer * 60) : matchData?.game_status?.time?.trim();
      const team1 = matchData?.event_team_a_id;
      const team2 = matchData?.event_team_b_id;
      const possession = matchData?.game_status?.possession;
      if (possession == team1) {

        dispatch(togglePossessionArrowTeamOne(true));
      }
      if (possession == team2) {

        dispatch(togglePossessionArrowTeamTwo(true));
      }



      const currentMinutes = Math.floor(currentTime / 60);

      const remainingSeconds = currentTime % 60;
      dispatch(setMinutes(currentMinutes));

      dispatch(setSeconds(remainingSeconds));
      dispatch(selectedQuarter(currentPeriod));

      dispatch(matchStatusUpdate(currentMatchStatus == "p" && 'pause' || currentMatchStatus == 'n' && 'Waiting to start'));
      dispatch(updateSLNoPayload(maxSlNo));


    }
  }, [])

  useEffect(() => {
    if (matchData) {

      dispatch(updateEventType(matchData?.team_a_event_type_id ? matchData?.team_a_event_type_id : matchData?.team_b_event_type_id))
    }
  }, [matchData])

  useEffect(() => {
    if (token && !matchData && !matchData?.game_status) {
      const fetchEventData = async () => {
        setLoading(true);
        try {
          const matchData = await getEventData(token);
          if (matchData) {
            dispatch(submitPlayersAndMatchData(matchData));
            const currentPeriod = matchData?.game_status?.period.trim();
            const scoreList = matchData?.game_data?.scoreList || [];
            const maxSlNo = scoreList.reduce((max, score) => Math.max(max, score.sl_no), 0);
            const currentTime = (matchData?.game_status?.time == 0 && !currentPeriod) ? (eventType5x5DefaultTimer * 60) : matchData?.game_status?.time?.trim();
            const team1 = matchData?.event_team_a_id;
            const team2 = matchData?.event_team_b_id;
            const possession = matchData?.game_status?.possession;
            if (possession == team1) {

              dispatch(togglePossessionArrowTeamOne(true));
            }
            if (possession == team2) {

              dispatch(togglePossessionArrowTeamTwo(true));
            }



            const currentMinutes = Math.floor(currentTime / 60);

            const remainingSeconds = currentTime % 60;
            dispatch(setMinutes(currentMinutes));

            dispatch(setSeconds(remainingSeconds));
            dispatch(selectedQuarter(currentPeriod));

            dispatch(matchStatusUpdate(currentMatchStatus == "p" && 'pause' || currentMatchStatus == 'n' && 'Waiting to start'));
            dispatch(updateSLNoPayload(maxSlNo));
            setLoading(false);
          }
        } catch (error) {
          console.error("Error fetching event data:", error);
          setLoading(false);
        }
      };

      fetchSettings();
      fetchEventData();
    }

  }, [token]);

  useEffect(() => {
    if (matchData?.team_a_event_type_id || matchData?.team_b_event_type_id) {
      const run = async () => {
        try {
          const data = await getPeriodList();
          dispatch(setQuarterOptions(data));
          // Ensure current quarter is valid for the available options
          const isCurrentQuarterValid = Array.isArray(data) && data.some((o) => o?.value === quarter);
          if (!isCurrentQuarterValid && Array.isArray(data) && data.length > 0) {
            dispatch(selectedQuarter(data[0].value));
          }
        } catch (error) {
          console.error('Error fetching period list:', error);
        }
      };
      run();
    }
  }, [matchData]);

  useEffect(() => {
    if (setting) {
      dispatch(fiveXFiveDefaultPeriod(setting?.time_period))
      dispatch(fiveXFiveOvertimePeriod(setting?.time_overtime));
      dispatch(topTimerWhenFoulCalled(setting?.time_overtime));
      dispatch(toggleShotClockCheck(setting?.shot_clock));
      dispatch(toggleShotClockViolation(setting?.rst_shot_clock_violation));
      dispatch(toggleFoul(setting?.rst_foul));
      dispatch(toggleTimeout(setting?.rst_timeout));
      dispatch(toggleOutOfBounds(setting?.rst_outofbounds));
      dispatch(toggleGoalWithinLast2Minutes(setting?.rst_goallast2min));
      dispatch(toggleGoalAnytimeDuringOvertime(setting?.rst_goal_anytime_overtime));
    }
  }, [setting])


  const [game_log, setGameLog] = useState([]);


  useEffect(() => {
    if (Array.isArray(game_subs)) {
      setGameLog([...game_subs, ...(game_data?.scoreList || [])]);
    } else {
      console.error("game_subs is not an array");
    }
  }, [game_subs, game_data]);



  const teamOneName = matchData?.team_a_short_name;
  const event_team_a_id = matchData?.event_team_a_id;
  const event_team_b_id = matchData?.event_team_b_id;
  const event_id = matchData?.event_id;
  const event_group_id = matchData?.event_group_id;
  const teamTwoName = matchData?.team_b_short_name;
  const teamOnePlayingPlayer = matchData?.team_a_rosters?.filter(
    (player) => player.is_Playing === true
  );

  const teamTwoPlayingPlayer = matchData?.team_b_rosters?.filter(
    (player) => player.is_Playing === true
  );

  const requiredPlayers = eventType === "3x3" ? 3 : 5;

  const teamOneJumpBallPlayer =
    matchData?.team_a_rosters?.find((p) => p.roster_id === jumpBallTeamAPlayerRosterId) || null;
  const teamTwoJumpBallPlayer =
    matchData?.team_b_rosters?.find((p) => p.roster_id === jumpBallTeamBPlayerRosterId) || null;

  // Hydrate jumpball selections from localStorage per event (so refresh doesn't lose them)
  useEffect(() => {
    if (!event_id) return;
    dispatch(resetJumpBallPlayers());
    try {
      const key = `jumpball_${event_id}`;
      const raw = localStorage.getItem(key);
      if (!raw) return;
      const parsed = JSON.parse(raw);
      if (parsed?.teamA) dispatch(setJumpBallTeamAPlayerRosterId(parsed.teamA));
      if (parsed?.teamB) dispatch(setJumpBallTeamBPlayerRosterId(parsed.teamB));
    } catch (e) {
      // ignore bad storage
    }
  }, [event_id]);

  const navigate = useNavigate();

  const teamOneBench = matchData?.length > 0 && matchData?.team_a_rosters
    .filter(
      (player) =>
        player.is_Playing === false && player.is_present
    )
  const teamTwoBench = matchData?.length > 0 && matchData?.team_b_rosters
    .filter(
      (player) =>
        player.is_Playing === false && player.is_present
    )


  const handleFieldLocation = (event) => {
    const localX = event.clientX - event.target.offsetLeft;
    const localY = event.clientY - event.target.offsetTop;

    setFieldLocation({ x: localX, y: localY });
  };

  const filteredPostingData = postingData && postingData?.filter((gameData) => {
    return !game_log.some(
      (postData) =>
        postData.score_period == gameData.score_period &&
        postData.score_timer == gameData.score_timer
    );
  });


  useEffect(() => {
    if (postingError) {

      dispatch(updateAllPostingDataStatusFailed());
    }
  }, [postingError]);

  const deletePostingDataFunction = (unique_id
  ) => {

    dispatch(deletePostingData(unique_id));
  };



  const addNewScoreMutation = useMutation((formData) => addNewScore(formData, token));

  const handleAddNewScore = async (playerId, t_id, value, line_id) => {

    const xPosition = fieldLocation.x || 0;
    const yPosition = fieldLocation.y || 0;

    const score_type = determineScoreType(
      point2,
      point3,
      point1,
      pointMiss1,
      assistPoint,
      reboundBlockPoint,
      teamReboundSections,
      foul,
      turnoverPoint,
      foulPT,
      foulPoint,
      value,
      game_data,
      t_id
    );

    // Use helper function to create data object
    const data = createScoreData(
      score_type,
      xPosition,
      yPosition,
      minutes,
      seconds,
      event_id,
      event_group_id,
      playerId,
      t_id,
      quarter,
      starState
    );

    if (data) {

      dispatch(deletePostingData({ ...data, loading: true, scorer_id: user_id }));
    }

    try {
      const response = await addNewScoreMutation.mutateAsync(data);

      dispatch(updateUndoStep());
      if (response.status === 201) {
        dispatch(gameData(response.data.game_data));
        setPostingError(false);
        setStarState(false);
        setTeamFoulSections("PF");
      }
    } catch (error) {
      setPostingError(true);
    }
  };


  const handleAddNewScoreReBulkInComponent = (unique_id) => {
    dispatch(handleAddNewScoreReBulk(
      unique_id,
      filteredPostingData,  // Pass the filtered data from your component
      setStarState,          // Pass the state setters from your component
      setTeamFoulSections,
      setPostingError
    ));

  };
  const handleReBulkScore = (unique_id) => {
    handleAddNewScoreReBulkInComponent(unique_id);
  };
  const handleTemporaryScore = (playerId, t_id, value) => {
    const fieldLocation = { x: 100, y: 200 };
    dispatch(handleScoreTemporaryData({
      playerId,
      t_id,
      value,
      fieldLocation,
      minutes,
      seconds,
      event_id,
      event_group_id,
      quarter,
      starState,
      scoreTemporaryData,
      point2,
      point3,
      point1,
      pointMiss1,
      pointMiss2,
      pointMiss3,
      assistPoint,
      reboundBlockPoint,
      teamReboundSections,
      teamTurnoverSections,
      foul,
      turnoverPoint,
      foulPT,
      foulPoint,
      user_id,
      sl_no
    }));
  };
  const handleBulkScore = () => {
    dispatch(handleAddNewScoreBulk(scoreTemporaryData, setStarState, setTeamFoulSections, setPostingError));
    setTimeout(() => {
      dispatch(sendTimerData({
        shotClockValue,
        possessionArrowTeamOne,
        possessionArrowTeamTwo,
        isRunning,
        minutes,
        seconds,
        event_id,
        event_group_id,
        quarter,
        event_team_a_id,
        event_team_b_id
      }))
    }, 100);
    setHideBlock(false);
  };
  function findPlayerTeam(rosterId) {
    const playerInTeamA = matchData?.team_a_rosters?.find(
      (player) => player.roster_id === rosterId
    );
    if (playerInTeamA) {
      return "teamA";
    }

    const playerInTeamB = matchData?.team_b_rosters?.find(
      (player) => player.roster_id === rosterId
    );
    if (playerInTeamB) {
      return "teamB";
    }

    return "Player not found in either team";
  }
  const maxPlayers = eventType === "5x5" ? 5 : 3;
  useEffect(() => {
    const teamAPlaying =
      matchData?.team_a_rosters?.filter((player) => player.is_Playing).length ==
      maxPlayers;
    const teamBPlaying =
      matchData?.team_b_rosters?.filter((player) => player.is_Playing).length ==
      maxPlayers;

    setTeamAPlayingCount(teamAPlaying);
    setTeamBPlayingCount(teamBPlaying);
  }, [matchData]);
  const handleDelScore = (type, data_id, eg_id, event_id) => {
    const token = localStorage.getItem("token");
    dispatch(handleScoreDelete(type, data_id, eg_id, event_id, token, setScoreDeleteModal, setScoreId, setDeleteLoading));
  };
  const handlePlayerSelectionOne = async (id) => {
    if (playerPointSelect === true) {
      if (actionPlayerId) {
        if (teamAssistSections) {
          setTeamAssistSections("Assist");

          dispatch(updateSLNo());
          handleTemporaryScore(id, event_team_a_id);
          setTimeout(() => {

            dispatch(playerAssistSelection(id));
          }, 200);
        }
        if (reboundSelections) {

          setTeamReboundSections("Rebound");
          setHideBlock(false);

          dispatch(updateSLNo());
          if (teamReboundSections == 'Block') {
            setHideBlock(true);

            handleTemporaryScore(id, event_team_a_id);

          } else {
            handleTemporaryScore(id, event_team_a_id);
            setHideBlock(false);


            setTimeout(() => {
              dispatch(playerAssistSelection(id));
            }, 200);
          }

        }
        if (turnoverSelections) {
          setTeamTurnoverSections("Steal");

          dispatch(updateSLNo());
          handleTemporaryScore(id, event_team_a_id);
          setTimeout(() => {

            dispatch(playerAssistSelection(id));
          }, 200);
        }
        if (foulActionsSelections) {

          dispatch(updateSLNo());
          handleTemporaryScore(id, event_team_a_id, "PF");
          setTimeout(() => {
            dispatch(playerAssistSelection(id));

          }, 200);
          if (matchStatus !== "pause" && !foulCheck) {
            startTimer(minutes, seconds);
          }


          setTimeout(() => {
            if (possessionArrowTeamTwo) {
              handleSelectPoint("TO_PT")
              setAutoTo(true);
            }
          }, 210);

        }
      } else {
        if (
          made2PT == "active" ||
          made3PT == "active" ||
          miss2PT == "active" ||
          miss3PT == "active"
        ) {
          if (!selectionAfterFieldGoalAttempt) {
            if (madePT) {
              if (staticMode) {
                dispatch(
                  playerSelectionTeamOne({
                    actionPlayerId: showShotChart ? id : staticMode ? null : id,
                    shortSelections: false,
                    shortFieldSelections: showShotChart ? true : false,
                    playerControlSelections: staticMode ? true : false,
                    playerPointSelect: showShotChart
                      ? true
                      : staticMode
                        ? !true
                        : !false,
                    made2PT: staticMode ? true : false,
                    made1PT: staticMode ? true : false,
                    made3PT: staticMode ? true : false,
                    miss1PT: staticMode ? true : false,
                    miss2PT: staticMode ? true : false,
                    miss3PT: staticMode ? true : false,
                    foulActions: staticMode ? true : false,
                    toActions: staticMode ? true : false,
                    playerSelectionsTeamOne: showShotChart
                      ? !false
                      : staticMode
                        ? !true
                        : !false,
                    playerSelectionsTeamTwo: showShotChart
                      ? false
                      : staticMode
                        ? !true
                        : !false,
                    assistSelections: showShotChart
                      ? false
                      : staticMode
                        ? false
                        : true,
                    point1: showShotChart ? point1 : null,
                    point2: showShotChart ? point2 : null,
                    point3: showShotChart ? point3 : null,
                    pointMiss1: showShotChart ? pointMiss1 : null,
                    pointMiss2: showShotChart ? pointMiss2 : null,
                    pointMiss3: showShotChart ? pointMiss3 : null,
                    assistPoint: showShotChart ? assistPoint : null,
                    reboundBlockPoint: showShotChart ? reboundBlockPoint : null,
                    turnoverPoint: showShotChart ? turnoverPoint : null,
                    foulPoint: showShotChart ? foulPoint : null,
                  })
                );

                if (!showShotChart) {
                  handleAddNewScore(id, event_team_a_id);
                }
              } else {
                dispatch(
                  playerSelectionTeamOne({
                    actionPlayerId: showShotChart ? id : staticMode ? null : id,
                    shortSelections: false,
                    shortFieldSelections: showShotChart ? true : false,
                    playerControlSelections: staticMode ? true : false,
                    playerPointSelect: showShotChart
                      ? true
                      : staticMode
                        ? !true
                        : !false,
                    made2PT: staticMode ? true : false,
                    made1PT: staticMode ? true : false,
                    made3PT: staticMode ? true : false,
                    miss1PT: staticMode ? true : false,
                    miss2PT: staticMode ? true : false,
                    miss3PT: staticMode ? true : false,
                    foulActions: staticMode ? true : false,
                    toActions: staticMode ? true : false,
                    playerSelectionsTeamOne: showShotChart
                      ? !false
                      : staticMode
                        ? !true
                        : !false,
                    playerSelectionsTeamTwo: showShotChart
                      ? false
                      : staticMode
                        ? !true
                        : !false,
                    assistSelections: showShotChart
                      ? false
                      : staticMode
                        ? false
                        : true,
                    point1: showShotChart ? point1 : staticMode ? point1 : null,
                    point2: showShotChart ? point2 : staticMode ? point2 : null,
                    point3: showShotChart ? point1 : staticMode ? point3 : null,
                    pointMiss1: showShotChart
                      ? pointMiss1
                      : staticMode
                        ? pointMiss1
                        : null,
                    pointMiss2: showShotChart
                      ? pointMiss2
                      : staticMode
                        ? pointMiss2
                        : null,
                    pointMiss3: showShotChart
                      ? pointMiss3
                      : staticMode
                        ? pointMiss3
                        : null,
                    assistPoint: showShotChart
                      ? null
                      : staticMode
                        ? null
                        : true,
                    reboundBlockPoint: showShotChart
                      ? reboundBlockPoint
                      : staticMode
                        ? reboundBlockPoint
                        : null,
                    foulPoint: showShotChart
                      ? foulPoint
                      : staticMode
                        ? foulPoint
                        : null,
                    turnoverPoint: showShotChart
                      ? turnoverPoint
                      : staticMode
                        ? foulPoint
                        : null,
                  })
                );

                setTeamAssistSections("Assist");
                setTeamReboundSections(null);
                dispatch(updateSLNo());
                if (!showShotChart) {
                  handleTemporaryScore(id, event_team_a_id);
                }
              }
            } else {

              dispatch(updateSLNo());
              handleTemporaryScore(id, event_team_a_id);

              setTimeout(() => {
                setTeamAssistSections(null);
                setTeamReboundSections("Rebound");
                dispatch(playerSelectionTeamOneMiss({
                  actionPlayerId: showShotChart ? id : staticMode ? null : id,
                  shortSelections: false,
                  shortFieldSelections: showShotChart ? true : false,
                  playerControlSelections: staticMode ? true : false,
                  playerPointSelect: showShotChart
                    ? true
                    : staticMode
                      ? !true
                      : !false,
                  made2PT: staticMode ? true : false,
                  made1PT: staticMode ? true : false,
                  made3PT: staticMode ? true : false,
                  miss1PT: staticMode ? true : false,
                  miss2PT: staticMode ? true : false,
                  miss3PT: staticMode ? true : false,
                  foulActions: staticMode ? true : false,
                  toActions: staticMode ? true : false,
                  playerSelectionsTeamOne: !false,
                  playerSelectionsTeamTwo: !false,
                  reboundSelections: missPT
                    ? true
                    : showShotChart
                      ? false
                      : staticMode
                        ? false
                        : true,
                  point1: showShotChart ? point1 : staticMode ? point1 : null,
                  point2: showShotChart ? point2 : staticMode ? point2 : null,
                  point3: showShotChart ? point3 : staticMode ? point3 : null,
                  pointMiss1: showShotChart
                    ? pointMiss1
                    : staticMode
                      ? pointMiss1
                      : null,
                  pointMiss2: showShotChart
                    ? pointMiss2
                    : staticMode
                      ? pointMiss2
                      : null,
                  pointMiss3: showShotChart
                    ? pointMiss3
                    : staticMode
                      ? pointMiss3
                      : null,
                  assistPoint: showShotChart
                    ? assistPoint
                    : staticMode
                      ? assistPoint
                      : null,
                  reboundBlockPoint: showShotChart
                    ? null
                    : staticMode
                      ? null
                      : true,
                  turnoverPoint: false,
                  foulPoint: showShotChart
                    ? foulPoint
                    : staticMode
                      ? foulPoint
                      : null,
                }));

              }, 200);
            }
          } else {


            dispatch(playerSelectionTeamOne({
              actionPlayerId: id,
              shortSelections: true,
              playerSelectionsTeamOne: true,
              playerPointSelect: !false,
              shortFieldSelections: false,
              playerControlSelections: false,
              made2PT: made2PT,
              made1PT: made1PT,
              made3PT: made3PT,
              miss1PT: miss1PT,
              miss2PT: miss2PT,
              miss3PT: miss3PT,
              foulActions: foulActions,
              toActions: toActions,
              point1: showShotChart ? point1 : null,
              point2: showShotChart ? point2 : null,
              point3: showShotChart ? point3 : null,
              pointMiss1: showShotChart ? pointMiss1 : null,
              pointMiss2: showShotChart ? pointMiss2 : null,
              pointMiss3: showShotChart ? pointMiss3 : null,
              assistPoint: showShotChart ? assistPoint : null,
              reboundBlockPoint: showShotChart ? reboundBlockPoint : null,
              turnoverPoint: showShotChart ? turnoverPoint : null,
              foulPoint: showShotChart ? foulPoint : null,
            }));

            if (!showShotChart)

              dispatch(updateSLNo());
            handleTemporaryScore(id, event_team_a_id, 494);
          }
        } else if (miss1PT == "active") {
          dispatch(playerSelectionTeamOne({
            actionPlayerId: id,
            shortSelections: false,
            shortFieldSelections: false,
            playerControlSelections: false,
            playerPointSelect: !false,
            made2PT: false,
            made1PT: false,
            made3PT: false,
            miss1PT: false,
            miss2PT: false,
            miss3PT: false,
            foulActions: false,
            toActions: false,
            playerSelectionsTeamOne: missPT
              ? false
              : showShotChart
                ? !false
                : staticMode
                  ? !true
                  : !false,
            playerSelectionsTeamTwo: missPT
              ? false
              : showShotChart
                ? false
                : staticMode
                  ? !true
                  : !false,
            reboundSelections: true,
            reboundBlockPoint: true,
          }));

          setTeamAssistSections(null);

          dispatch(updateSLNo());
          handleTemporaryScore(id, event_team_a_id);
        } else if (foul) {
          dispatch(playerSelectionTeamOne({
            actionPlayerId: id,
            shortSelections: false,
            shortFieldSelections: false,
            playerControlSelections: false,
            playerPointSelect: !false,
            made2PT: false,
            made1PT: false,
            made3PT: false,
            miss1PT: false,
            miss2PT: false,
            miss3PT: false,
            foulActions: false,
            toActions: false,
            playerSelectionsTeamOne: true,
            turnoverSelections: true,
            turnoverPoint: true,
          }));

          setTeamReboundSections(null);
          setTeamAssistSections(null);
          if (autoTo) {
            setAutoTo(false);

          } else {
            setTeamTurnoverSections("Steal");
          }


          dispatch(updateSLNo());
          handleTemporaryScore(id, event_team_a_id, 596);
        } else if (foulActions == "active") {

          dispatch(updateSLNo());
          handleTemporaryScore(id, event_team_a_id, 623);
          setTimeout(() => {
            dispatch(playerSelectionTeamOne({
              actionPlayerId: id,
              shortSelections: false,
              shortFieldSelections: false,
              playerControlSelections: false,
              playerPointSelect: !false,
              made2PT: false,
              made1PT: false,
              made3PT: false,
              miss1PT: false,
              miss2PT: false,
              miss3PT: false,
              foulActions: false,
              toActions: false,
              playerSelectionsTeamOne: true,
              foulActionsSelections: true,
              foulPoint: true,
            }));

            setTeamReboundSections(null);
            setTeamAssistSections(null);
            setTeamTurnoverSections(null);
          }, 200);
        } else {
          if (staticMode) {

            dispatch(playerAssistSelection());
            handleAddNewScore(id, event_team_a_id);
          } else {
            dispatch(playerSelectionTeamOne({
              actionPlayerId: showShotChart ? id : staticMode ? null : id,
              shortSelections: false,
              shortFieldSelections: showShotChart ? true : false,
              playerControlSelections: staticMode ? true : false,
              playerPointSelect: showShotChart
                ? true
                : staticMode
                  ? !true
                  : !false,
              made2PT: staticMode ? true : false,
              made1PT: staticMode ? true : false,
              made3PT: staticMode ? true : false,
              miss1PT: staticMode ? true : false,
              miss2PT: staticMode ? true : false,
              miss3PT: staticMode ? true : false,
              foulActions: staticMode ? true : false,
              toActions: staticMode ? true : false,
              playerSelectionsTeamOne: showShotChart
                ? !false
                : staticMode
                  ? !true
                  : !false,
              playerSelectionsTeamTwo: showShotChart
                ? false
                : staticMode
                  ? !true
                  : !false,
              assistSelections: showShotChart
                ? false
                : staticMode
                  ? false
                  : true,
              point1: showShotChart ? point1 : staticMode ? point1 : null,
              point2: showShotChart ? point2 : staticMode ? point2 : null,
              point3: showShotChart ? point3 : staticMode ? point3 : null,
              pointMiss1: showShotChart
                ? pointMiss1
                : staticMode
                  ? pointMiss1
                  : null,
              pointMiss2: showShotChart
                ? pointMiss2
                : staticMode
                  ? pointMiss2
                  : null,
              pointMiss3: showShotChart
                ? pointMiss3
                : staticMode
                  ? pointMiss3
                  : null,
              assistPoint: showShotChart ? null : staticMode ? null : true,
              reboundBlockPoint: showShotChart
                ? reboundBlockPoint
                : staticMode
                  ? reboundBlockPoint
                  : null,
              foulPoint: showShotChart
                ? foulPoint
                : staticMode
                  ? foulPoint
                  : null,
              turnoverPoint: showShotChart
                ? turnoverPoint
                : staticMode
                  ? foulPoint
                  : null,
            }));

            setTeamAssistSections("Assist");
            setTeamReboundSections(null);
            if (!showShotChart) {

              dispatch(updateSLNo());
              handleTemporaryScore(id, event_team_a_id);
            }
          }
        }
      }
    }
  };
  const handlePlayerSelectionTwo = (id) => {
    if (playerPointSelect === true) {
      if (actionPlayerId) {
        if (teamAssistSections) {
          setTeamAssistSections("Assist");

          dispatch(updateSLNo());
          handleTemporaryScore(id, event_team_b_id);
          setTimeout(() => {
            dispatch(playerAssistSelection(id));

          }, 200);
        }
        if (reboundSelections) {
          setTeamReboundSections("Rebound");
          setHideBlock(false);

          dispatch(updateSLNo());

          if (teamReboundSections == 'Block') {
            setHideBlock(true);

            handleTemporaryScore(id, event_team_b_id);

          } else {
            handleTemporaryScore(id, event_team_b_id);
            setHideBlock(false);

            setTimeout(() => {
              dispatch(playerAssistSelection(id));
            }, 200);

          }
        }
        if (turnoverSelections) {
          setTeamTurnoverSections("Steal");


          dispatch(updateSLNo());
          handleTemporaryScore(id, event_team_b_id, 1111);
          setTimeout(() => {

            dispatch(playerAssistSelection(id));
          }, 200);
        }
        if (foulActionsSelections) {

          dispatch(updateSLNo());
          handleTemporaryScore(id, event_team_b_id, "PF");
          setTimeout(() => {

            dispatch(playerAssistSelection(id));

          }, 200);
          setTimeout(() => {


            if (possessionArrowTeamOne) {
              handleSelectPoint("TO_PT")
              setAutoTo(true);
            }
          }, 210);

          if (matchStatus !== "pause" && !foulCheck) {
            startTimer(minutes, seconds);
          }
        }
      } else {
        if (
          made2PT == "active" ||
          made3PT == "active" ||
          miss2PT == "active" ||
          miss3PT == "active"
        ) {
          if (!selectionAfterFieldGoalAttempt) {
            if (madePT) {
              if (staticMode) {
                dispatch(playerSelectionTeamTwo({
                  actionPlayerId: showShotChart ? id : staticMode ? null : id,
                  shortSelections: false,
                  shortFieldSelections: showShotChart ? true : false,
                  playerControlSelections: staticMode ? true : false,
                  playerPointSelect: showShotChart
                    ? true
                    : staticMode
                      ? !true
                      : !false,
                  made2PT: staticMode ? true : false,
                  made1PT: staticMode ? true : false,
                  made3PT: staticMode ? true : false,
                  miss1PT: staticMode ? true : false,
                  miss2PT: staticMode ? true : false,
                  miss3PT: staticMode ? true : false,
                  foulActions: staticMode ? true : false,
                  toActions: staticMode ? true : false,
                  playerSelectionsTeamTwo: showShotChart
                    ? !false
                    : staticMode
                      ? !true
                      : !false,
                  playerSelectionsTeamOne: showShotChart
                    ? false
                    : staticMode
                      ? !true
                      : !false,
                  assistSelections: showShotChart
                    ? false
                    : staticMode
                      ? false
                      : true,
                  point1: showShotChart ? point1 : null,
                  point2: showShotChart ? point2 : null,
                  point3: showShotChart ? point3 : null,
                  pointMiss1: showShotChart ? pointMiss1 : null,
                  pointMiss2: showShotChart ? pointMiss2 : null,
                  pointMiss3: showShotChart ? pointMiss3 : null,
                  assistPoint: showShotChart ? assistPoint : null,
                  reboundBlockPoint: showShotChart ? reboundBlockPoint : null,
                  turnoverPoint: showShotChart ? turnoverPoint : null,
                  foulPoint: showShotChart ? foulPoint : null,
                }));

                if (!showShotChart) {
                  handleAddNewScore(id, event_team_b_id);
                }
              } else {
                dispatch(playerSelectionTeamTwo({
                  actionPlayerId: showShotChart ? id : staticMode ? null : id,
                  shortSelections: false,
                  shortFieldSelections: showShotChart ? true : false,
                  playerControlSelections: staticMode ? true : false,
                  playerPointSelect: showShotChart
                    ? true
                    : staticMode
                      ? !true
                      : !false,
                  made2PT: staticMode ? true : false,
                  made1PT: staticMode ? true : false,
                  made3PT: staticMode ? true : false,
                  miss1PT: staticMode ? true : false,
                  miss2PT: staticMode ? true : false,
                  miss3PT: staticMode ? true : false,
                  foulActions: staticMode ? true : false,
                  toActions: staticMode ? true : false,
                  playerSelectionsTeamTwo: showShotChart
                    ? !false
                    : staticMode
                      ? !true
                      : !false,
                  playerSelectionsTeamOne: showShotChart
                    ? false
                    : staticMode
                      ? !true
                      : !false,
                  assistSelections: showShotChart
                    ? false
                    : staticMode
                      ? false
                      : true,
                  point1: showShotChart ? point1 : staticMode ? point1 : null,
                  point2: showShotChart ? point2 : staticMode ? point2 : null,
                  point3: showShotChart ? point1 : staticMode ? point3 : null,
                  pointMiss1: showShotChart
                    ? pointMiss1
                    : staticMode
                      ? pointMiss1
                      : null,
                  pointMiss2: showShotChart
                    ? pointMiss2
                    : staticMode
                      ? pointMiss2
                      : null,
                  pointMiss3: showShotChart
                    ? pointMiss3
                    : staticMode
                      ? pointMiss3
                      : null,
                  assistPoint: showShotChart
                    ? null
                    : staticMode
                      ? null
                      : true,
                  reboundBlockPoint: showShotChart
                    ? reboundBlockPoint
                    : staticMode
                      ? reboundBlockPoint
                      : null,
                  foulPoint: showShotChart
                    ? foulPoint
                    : staticMode
                      ? foulPoint
                      : null,
                  turnoverPoint: showShotChart
                    ? turnoverPoint
                    : staticMode
                      ? turnoverPoint
                      : null,
                }));

                setTeamAssistSections("Assist");
                setTeamReboundSections(null);
                if (!showShotChart) {

                  dispatch(updateSLNo());
                  handleTemporaryScore(id, event_team_b_id);
                }
              }
            } else {

              dispatch(updateSLNo());
              handleTemporaryScore(id, event_team_b_id);

              setTimeout(() => {
                setTeamAssistSections(null);
                setTeamReboundSections("Rebound");
                dispatch(playerSelectionTeamTwoMiss({
                  actionPlayerId: showShotChart ? id : staticMode ? null : id,
                  shortSelections: false,
                  shortFieldSelections: showShotChart ? true : false,
                  playerControlSelections: staticMode ? true : false,
                  playerPointSelect: showShotChart
                    ? true
                    : staticMode
                      ? !true
                      : !false,
                  made2PT: staticMode ? true : false,
                  made1PT: staticMode ? true : false,
                  made3PT: staticMode ? true : false,
                  miss1PT: staticMode ? true : false,
                  miss2PT: staticMode ? true : false,
                  miss3PT: staticMode ? true : false,
                  foulActions: staticMode ? true : false,
                  toActions: staticMode ? true : false,

                  playerSelectionsTeamTwo: !false,
                  playerSelectionsTeamOne: !false,

                  reboundSelections: missPT
                    ? true
                    : showShotChart
                      ? false
                      : staticMode
                        ? false
                        : true,
                  point1: showShotChart ? point1 : staticMode ? point1 : null,
                  point2: showShotChart ? point2 : staticMode ? point2 : null,
                  point3: showShotChart ? point1 : staticMode ? point3 : null,
                  pointMiss1: showShotChart
                    ? pointMiss1
                    : staticMode
                      ? pointMiss1
                      : null,
                  pointMiss2: showShotChart
                    ? pointMiss2
                    : staticMode
                      ? pointMiss2
                      : null,
                  pointMiss3: showShotChart
                    ? pointMiss3
                    : staticMode
                      ? pointMiss3
                      : null,
                  assistPoint: showShotChart
                    ? assistPoint
                    : staticMode
                      ? assistPoint
                      : null,
                  reboundBlockPoint: showShotChart
                    ? null
                    : staticMode
                      ? null
                      : true,
                  turnoverPoint: false,
                  foulPoint: showShotChart
                    ? foulPoint
                    : staticMode
                      ? foulPoint
                      : null,
                }));

              }, 200);
            }
          } else {
            dispatch(playerSelectionTeamTwo({
              actionPlayerId: id,
              shortSelections: true,
              playerSelectionsTeamTwo: true,
              playerPointSelect: !false,
              shortFieldSelections: false,
              playerControlSelections: false,
              made2PT: made2PT,
              made1PT: made1PT,
              made3PT: made3PT,
              miss1PT: miss1PT,
              miss2PT: miss2PT,
              miss3PT: miss3PT,
              foulActions: foulActions,
              toActions: toActions,
              point1: showShotChart ? point1 : null,
              point2: showShotChart ? point2 : null,
              point3: showShotChart ? point3 : null,
              pointMiss1: showShotChart ? pointMiss1 : null,
              pointMiss2: showShotChart ? pointMiss2 : null,
              pointMiss3: showShotChart ? pointMiss3 : null,
              assistPoint: showShotChart ? assistPoint : null,
              reboundBlockPoint: showShotChart ? reboundBlockPoint : null,
              turnoverPoint: showShotChart ? turnoverPoint : null,
              foulPoint: showShotChart ? foulPoint : null,
            }));


            if (!showShotChart) {

              dispatch(updateSLNo());
              handleTemporaryScore(id, event_team_b_id);
            }
          }
        } else if (miss1PT == "active") {
          dispatch(playerSelectionTeamTwo({
            actionPlayerId: id,
            shortSelections: false,
            shortFieldSelections: false,
            playerControlSelections: false,
            playerPointSelect: !false,
            made2PT: false,
            made1PT: false,
            made3PT: false,
            miss1PT: false,
            miss2PT: false,
            miss3PT: false,
            foulActions: staticMode ? true : false,
            toActions: staticMode ? true : false,

            playerSelectionsTeamTwo: missPT
              ? false
              : showShotChart
                ? !false
                : staticMode
                  ? !true
                  : !false,
            playerSelectionsTeamOne: missPT
              ? false
              : showShotChart
                ? false
                : staticMode
                  ? !true
                  : !false,

            reboundSelections: true,
            reboundBlockPoint: true,
          }));

          setTeamAssistSections(null);
          dispatch(updateSLNo());
          handleTemporaryScore(id, event_team_b_id);
        } else if (foul) {
          dispatch(playerSelectionTeamTwo({
            actionPlayerId: id,
            shortSelections: false,
            shortFieldSelections: false,
            playerControlSelections: false,
            playerPointSelect: !false,
            made2PT: false,
            made1PT: false,
            made3PT: false,
            miss1PT: false,
            miss2PT: false,
            miss3PT: false,
            foulActions: false,
            toActions: false,
            playerSelectionsTeamTwo: true,
            turnoverSelections: true,
            turnoverPoint: true,
          }));

          setTeamReboundSections(null);
          setTeamAssistSections(null);
          if (autoTo) {
            setAutoTo(false);

          } else {
            setTeamTurnoverSections("Steal");
          }



          dispatch(updateSLNo());
          handleTemporaryScore(id, event_team_b_id);
        } else if (foulActions == "active") {

          dispatch(updateSLNo());
          handleTemporaryScore(id, event_team_b_id);
          setTimeout(() => {
            dispatch(playerSelectionTeamTwo({
              actionPlayerId: id,
              shortSelections: false,
              shortFieldSelections: false,
              playerControlSelections: false,

              playerPointSelect: !false,
              made2PT: false,
              made1PT: false,
              made3PT: false,
              miss1PT: false,
              miss2PT: false,
              miss3PT: false,
              foulActions: false,
              toActions: false,

              playerSelectionsTeamTwo: true,

              foulActionsSelections: true,
              foulPoint: true,
            }));

            setTeamReboundSections(null);
            setTeamAssistSections(null);
            setTeamTurnoverSections(null);
          }, 200);
        } else {


          if (staticMode) {

            dispatch(playerAssistSelection());
            handleAddNewScore(id, event_team_b_id);
          } else {
            dispatch(playerSelectionTeamTwo({
              actionPlayerId: showShotChart ? id : staticMode ? null : id,
              shortSelections: false,
              shortFieldSelections: showShotChart ? true : false,
              playerControlSelections: staticMode ? true : false,

              playerPointSelect: showShotChart
                ? true
                : staticMode
                  ? !true
                  : !false,
              made2PT: staticMode ? true : false,
              made1PT: staticMode ? true : false,
              made3PT: staticMode ? true : false,
              miss1PT: staticMode ? true : false,
              miss2PT: staticMode ? true : false,
              miss3PT: staticMode ? true : false,
              foulActions: staticMode ? true : false,
              toActions: staticMode ? true : false,

              playerSelectionsTeamTwo: showShotChart
                ? !false
                : staticMode
                  ? !true
                  : !false,
              playerSelectionsTeamOne: showShotChart
                ? false
                : staticMode
                  ? !true
                  : !false,

              assistSelections: showShotChart
                ? false
                : staticMode
                  ? false
                  : true,

              point1: showShotChart ? point1 : staticMode ? point1 : null,
              point2: showShotChart ? point2 : staticMode ? point2 : null,
              point3: showShotChart ? point3 : staticMode ? point3 : null,
              pointMiss1: showShotChart
                ? pointMiss1
                : staticMode
                  ? pointMiss1
                  : null,
              pointMiss2: showShotChart
                ? pointMiss2
                : staticMode
                  ? pointMiss2
                  : null,
              pointMiss3: showShotChart
                ? pointMiss3
                : staticMode
                  ? pointMiss3
                  : null,
              assistPoint: showShotChart ? null : staticMode ? null : true,
              reboundBlockPoint: showShotChart
                ? reboundBlockPoint
                : staticMode
                  ? reboundBlockPoint
                  : null,
              foulPoint: showShotChart
                ? foulPoint
                : staticMode
                  ? foulPoint
                  : null,
              turnoverPoint: showShotChart
                ? turnoverPoint
                : staticMode
                  ? turnoverPoint
                  : null,
            }));

            setTeamAssistSections("Assist");
            setTeamReboundSections(null);
            if (!showShotChart) {


              dispatch(updateSLNo());
              handleTemporaryScore(id, event_team_b_id);
            }
          }
        }
      }
    }
  };
  useEffect(() => {
    if (scoreTemporaryData.length > 1) {
      if (playerPointSelect === true) {
        if (actionPlayerId) {
          if (teamAssistSections) {
            handleBulkScore();

          }
          if (reboundSelections) {
            if (!hideBlock) {



              handleBulkScore();
            }


          }
          if (turnoverSelections) {

            handleBulkScore();
          }
          if (foulActionsSelections) {
            handleBulkScore();

          }
        }
      }
    }
    if (scoreTemporaryData.length === 1) {
      if (playerPointSelect === true) {
        if (actionPlayerId) {
          if (foulActionsSelections && teamFoulSections == "TF") {
            handleBulkScore();
          }
        }
      }
    }
  }, [scoreTemporaryData]);
  const handlePlayerShot = (id) => {
    setShortSelectionsState(null);
    // remember this
    if (showShotChart) {
      dispatch(shortFieldSelection({
        shortFieldSelections: true,
        shortSelections: true,
        actionPlayerId: id,

        playerPointSelect: true,
        playerControlSelections: !true,
        playerSelectionsTeamOne: playerSelectionsTeamOne,
        playerSelectionsTeamTwo: playerSelectionsTeamTwo,

      }));

    } else {
      if (playerSelectionsTeamOne) {
        if (madePT) {
          if (staticMode) {
            dispatch(shortFieldSelection({
              shortFieldSelections: false,
              actionPlayerId: staticMode ? null : id,
              shortSelections: false,
              playerControlSelections: staticMode ? true : false,
              playerPointSelect: staticMode ? false : true,
              made2PT: staticMode ? true : false,
              made1PT: staticMode ? true : false,
              made3PT: staticMode ? true : false,
              miss1PT: staticMode ? true : false,
              miss2PT: staticMode ? true : false,
              miss3PT: staticMode ? true : false,
              foulActions: staticMode ? true : false,
              toActions: staticMode ? true : false,
              playerSelectionsTeamOne: showShotChart
                ? !false
                : staticMode
                  ? !true
                  : !false,
              playerSelectionsTeamTwo: false,
              assistSelections: showShotChart
                ? false
                : staticMode
                  ? false
                  : true,

            }));

            handleAddNewScore(id, event_team_a_id);
          } else {
            dispatch(shortFieldSelection({
              shortFieldSelections: false,
              actionPlayerId: staticMode ? null : id,
              shortSelections: false,
              playerControlSelections: staticMode ? true : false,
              playerPointSelect: staticMode ? false : true,
              made2PT: staticMode ? true : false,
              made1PT: staticMode ? true : false,
              made3PT: staticMode ? true : false,
              miss1PT: staticMode ? true : false,
              miss2PT: staticMode ? true : false,
              miss3PT: staticMode ? true : false,
              assistPoint: showShotChart
                ? !false
                : staticMode
                  ? !true
                  : !false,
              foulActions: staticMode ? true : false,
              toActions: staticMode ? true : false,
              playerSelectionsTeamOne: showShotChart
                ? !false
                : staticMode
                  ? !true
                  : !false,
              playerSelectionsTeamTwo: false,

              assistSelections: madePT
                ? true
                : showShotChart
                  ? false
                  : staticMode
                    ? false
                    : true,

            }));

            setTeamAssistSections("Assist");
            setTeamReboundSections(null);
          }
        } else {
          dispatch(shortFieldSelection({
            shortFieldSelections: false,
            actionPlayerId: staticMode ? null : id,
            shortSelections: false,
            playerControlSelections: staticMode ? true : false,
            playerPointSelect: staticMode ? false : true,
            made2PT: staticMode ? true : false,
            made1PT: staticMode ? true : false,
            made3PT: staticMode ? true : false,
            miss1PT: staticMode ? true : false,
            miss2PT: staticMode ? true : false,
            miss3PT: staticMode ? true : false,
            foulActions: staticMode ? true : false,
            toActions: staticMode ? true : false,
            playerSelectionsTeamOne: missPT
              ? false
              : showShotChart
                ? !false
                : staticMode
                  ? !true
                  : !false,
            playerSelectionsTeamTwo: false,

            reboundSelections: missPT
              ? true
              : showShotChart
                ? false
                : staticMode
                  ? false
                  : true,
          }));

          setTeamAssistSections(null);
          setTeamReboundSections("Rebound");
        }
      } else {
        if (madePT) {
          if (staticMode) {
            dispatch(shortFieldSelection({
              shortFieldSelections: false,
              actionPlayerId: staticMode ? null : id,
              shortSelections: false,
              playerControlSelections: staticMode ? true : false,
              playerPointSelect: staticMode ? false : true,
              made2PT: staticMode ? true : false,
              made1PT: staticMode ? true : false,
              made3PT: staticMode ? true : false,
              miss1PT: staticMode ? true : false,
              miss2PT: staticMode ? true : false,
              miss3PT: staticMode ? true : false,
              foulActions: staticMode ? true : false,
              toActions: staticMode ? true : false,
              playerSelectionsTeamTwo: showShotChart
                ? !false
                : staticMode
                  ? !true
                  : !false,
              playerSelectionsTeamOne: false,

              assistSelections: showShotChart
                ? false
                : staticMode
                  ? false
                  : true,
            }));

            handleAddNewScore(id, event_team_b_id);
          } else {
            dispatch(shortFieldSelection({
              shortFieldSelections: false,
              actionPlayerId: staticMode ? null : id,
              shortSelections: false,
              playerControlSelections: staticMode ? true : false,
              playerPointSelect: staticMode ? false : true,
              made2PT: staticMode ? true : false,
              made1PT: staticMode ? true : false,
              made3PT: staticMode ? true : false,
              miss1PT: staticMode ? true : false,
              miss2PT: staticMode ? true : false,
              miss3PT: staticMode ? true : false,
              assistPoint: showShotChart
                ? !false
                : staticMode
                  ? !true
                  : !false,
              foulActions: staticMode ? true : false,
              toActions: staticMode ? true : false,
              playerSelectionsTeamTwo: showShotChart
                ? !false
                : staticMode
                  ? !true
                  : !false,
              playerSelectionsTeamOne: false,

              assistSelections: madePT ? true : staticMode ? false : true,

            }));

            setTeamAssistSections("Assist");
            setTeamReboundSections(null);
          }
        } else {
          dispatch(shortFieldSelection({
            shortFieldSelections: false,
            actionPlayerId: staticMode ? null : id,
            shortSelections: false,
            playerControlSelections: staticMode ? true : false,
            playerPointSelect: staticMode ? false : true,
            made2PT: staticMode ? true : false,
            made1PT: staticMode ? true : false,
            made3PT: staticMode ? true : false,
            miss1PT: staticMode ? true : false,
            miss2PT: staticMode ? true : false,
            miss3PT: staticMode ? true : false,
            foulActions: staticMode ? true : false,
            toActions: staticMode ? true : false,
            playerSelectionsTeamTwo: missPT
              ? false
              : showShotChart
                ? !false
                : staticMode
                  ? !true
                  : !false,
            playerSelectionsTeamOne: false,

            reboundSelections: missPT ? true : staticMode ? false : true,
          }));

          setTeamAssistSections(null);
          setTeamReboundSections("Rebound");
        }
      }
    }
  };
  const handleFieldScore = (id) => {
    if (staticMode) {
      if (playerSelectionsTeamOne) {
        dispatch(playerAssistSection({
          actionPlayerId: staticMode && null,
          playerControlSelections: staticMode ? true : false,
          playerPointSelect: staticMode ? false : true,
          made2PT: staticMode ? true : false,
          made1PT: staticMode ? true : false,
          made3PT: staticMode ? true : false,
          miss1PT: staticMode ? true : false,
          miss2PT: staticMode ? true : false,
          miss3PT: staticMode ? true : false,
          foulActions: staticMode ? true : false,
          toActions: staticMode ? true : false,
          playerSelectionsTeamOne: false,
          playerSelectionsTeamTwo: false,
          assistSelections: false,

        }));

        handleAddNewScore(id, event_team_a_id);
      } else if (playerSelectionsTeamTwo) {
        dispatch(playerAssistSection({
          actionPlayerId: staticMode && null,
          playerControlSelections: staticMode ? true : false,
          playerPointSelect: staticMode ? false : true,
          made2PT: staticMode ? true : false,
          made1PT: staticMode ? true : false,
          made3PT: staticMode ? true : false,
          miss1PT: staticMode ? true : false,
          miss2PT: staticMode ? true : false,
          miss3PT: staticMode ? true : false,
          foulActions: staticMode ? true : false,
          toActions: staticMode ? true : false,
          playerSelectionsTeamOne: false,
          playerSelectionsTeamTwo: false,
          assistSelections: false,

        }));

        handleAddNewScore(id, event_team_b_id);
      }
    } else {
      if (madePT) {
        dispatch(playerAssistSection({
          actionPlayerId: staticMode ? null : id,
          playerPointSelect: staticMode ? false : true,
          playerSelectionsTeamOne: playerSelectionsTeamOne,
          playerSelectionsTeamTwo: playerSelectionsTeamTwo,
          assistSelections: true,
          point1: staticMode ? point1 : null,
          point2: staticMode ? point2 : null,
          point3: staticMode ? point3 : null,
          pointMiss1: staticMode ? pointMiss1 : null,
          pointMiss2: staticMode ? pointMiss2 : null,
          pointMiss3: staticMode ? pointMiss3 : null,
          assistPoint: staticMode ? assistPoint : true,
          reboundBlockPoint: staticMode ? reboundBlockPoint : null,
          turnoverPoint: staticMode ? turnoverPoint : null,
          foulPoint: staticMode ? foulPoint : null,
        }));

        setTeamAssistSections("Assist");
        setTeamReboundSections(null);
        if (showShotChart && playerSelectionsTeamOne) {

          dispatch(updateSLNo());
          handleTemporaryScore(id, event_team_a_id, 1177);
        }
        if (showShotChart && playerSelectionsTeamTwo) {

          dispatch(updateSLNo());
          handleTemporaryScore(id, event_team_b_id, 1181);
        }
      } else {
        dispatch(playerAssistSection({
          actionPlayerId: staticMode ? null : id,
          playerPointSelect: staticMode ? false : true,
          playerSelectionsTeamOne: missPT ? false : playerSelectionsTeamOne,
          playerSelectionsTeamTwo: missPT ? false : playerSelectionsTeamTwo,
          reboundSelections: true,
          reboundBlockPoint: true,
        }));

        setTeamAssistSections(null);
        setTeamReboundSections("Rebound");
        if (playerSelectionsTeamOne) {

          dispatch(updateSLNo());
          handleTemporaryScore(id, event_team_a_id, 1199);
        }
        if (playerSelectionsTeamTwo) {

          dispatch(updateSLNo());
          handleTemporaryScore(id, event_team_b_id, 1202);
        }
      }
    }
  };
  const handleTeamOneColor = (color) => {
    dispatch(teamOneColorSet(color.hex));
  };
  const handleTeamTwoColor = (color) => {
    dispatch(teamTwoColorSet(color.hex));
  };

  const handleSelectPoint = (value) => {
    if (!isRunning && !shotClock && shotClockCheck && (shotClockViolation || foulCheck || timeout || outOfBounds)) {
      toast.error("Please turn on main clock or shot clock");
    } else if (!isRunning && !shotClock && shotClockCheck && !shotClockViolation && !foulCheck && !timeout && !outOfBounds && timeoutCheck) {
      toast.error("Please turn on main clock");
    } else if (!shotClock && shotClockCheck) {
      toast.error("Please turn on shot clock");
    } else {

      dispatch(handlePointSelect(value));
    }
  };
  const handleAssistPart = (value, id) => {
    if (value == "Assist") {
      setTeamAssistSections(value);
    } else {


      dispatch(playerAssistSelection());
      handleBulkScore();
    }
  };
  const handleTurnoverPart = (value) => {

    if (value == "Steal") {

      setTeamTurnoverSections(value);
    } else {


      dispatch(playerAssistSelection());
      handleBulkScore();

    }
  };
  const handleFoulPart = (value, id) => {
    setTeamFoulSections(value);
    if (value) {
      if (value == "PF") {
      } else if (value == "TF") {
        const t_id = scoreTemporaryData[0]?.t_id;
        dispatch(updateSLNo());
        const lastPostingData = postingData[postingData.length - 1];

        if (lastPostingData?.score_type == 'personalFoul') {

          dispatch(deletePostingData(lastPostingData?.unique_id))
        }
        handleTemporaryScore(id, t_id, value);
        setTimeout(() => {
          dispatch(playerAssistSelection());
        }
          , 200);

        if (matchStatus !== "pause" && !shotClockCheck) {
          startTimer(minutes, seconds);
        }
      }
    }
  };
  const handleReboundPart = (value, id) => {
    if (value == "Rebound") {
      setTeamReboundSections(value);
    } else if (value == "Block") {
      setTeamReboundSections(value);
    } else {
      // dispatch({ type: "PLAYER_ASSIST_SELECTION" });
      dispatch(playerAssistSelection());
      handleBulkScore(1870);
    }
  };
  const handleChange = (value) => {
    setRangeValue(value);
    setRangesliderState(true);
  };

  useEffect(() => {
    if (rangesliderState) {
      setTimeout(() => handlePlayerShot(actionPlayerId), 1000);
    }
  }, [rangeValue, rangesliderState]);



  const handleStart = async (currentIsRunning, timeoutProps) => {

    if (!quarter) {
      toast.error("Please Select Period");
    } else if (quarter == 'NotStarted') {
      toast.error("Please Select Period");
    } else if (!teamAPlayingCount) {
      toast.error("Please Team 1 Active Player");
    } else if (!teamBPlayingCount) {
      toast.error("Please Team 2 Active Player");
    } else if (quarter && teamBPlayingCount && teamAPlayingCount) {
      dispatch(setIsRunning(!currentIsRunning));
      if (!currentIsRunning) {

        startNewTimer();
        startTimer(minutes, seconds);
        setTeamTwoColorSection(false);
        setTeamOneColorSection(false);
        sendTeamOneData();
        sendTeamTwoData();
        dispatch(toggleTimeout(true));

        if (!shotClockValue <= 0 && !timeoutCheck && shotClockCheck) {

          startJumpBallClock(shotClockValue)
        }
        if (!shotClockValue <= 0 && timeoutProps && shotClockCheck && timeoutCheck) {

          startJumpBallClock(shotClockValue)
        }


      } else {

        stopJumpBallClock();
        stopTimer();
        stopNewTimer();
        sendTeamOneData();
        sendTeamTwoData();
      }

      dispatch(matchStatusUpdate(!currentIsRunning ? "live" : "pause"));
      dispatch(sendTimerData({
        shotClockValue,
        possessionArrowTeamOne,
        possessionArrowTeamTwo,
        currentIsRunning,
        minutes,
        seconds,
        event_id,
        event_group_id,
        quarter,
        event_team_a_id,
        event_team_b_id
      }))
      // dispatch(toggleTimeout(isRunning ? false : true));

    }
  };

  useEffect(() => {
    if (shotClockValue <= 0 && shotClockViolation) {
      handleStart(isRunning);
    } else if (shotClockValue <= 0 && foulCheck && (foul || foulActions == "active")) {
      handleStart(isRunning);
    } else if (shotClockValue <= 0 && timeout) {
      // handleStart(false);
    } else if (shotClockValue <= 0 && outOfBounds && (toActions == "active" || toPT)) {
      handleStart(isRunning);
    } else if (shotClockValue <= 0 && goalWithinLast2Minutes) {
      handleStart(isRunning);
    } else if (shotClockValue <= 0 && goalAnytimeDuringOvertime) {
      handleStart(isRunning);
    } else {
      // handleStart(isRunning);
    }
  }, [shotClock])


  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === ' ') {
        e.preventDefault(); // Prevent default spacebar action (scrolling)
        handleStart(isRunning);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isRunning, minutes, seconds, quarter, teamAPlayingCount, teamBPlayingCount]);

  const toggleTimer = () => {
    handleStart()
  };

  const handleStop = () => {
    stopTimer();
  };

  const handleQuarterChange = (e) => {
    const selectedQuarterEvent = e;
    if (eventType == "5x5") {
      if (selectedQuarterEvent == "Overtime") {
        dispatch(setMinutes(eventType5x5OvertimeTimer));
        dispatch(setSeconds(0));
        sendTeamOneData();
        sendTeamTwoData();
      } else {
        dispatch(setMinutes(eventType5x5DefaultTimer));
        dispatch(setSeconds(0));
        sendTeamOneData();
        sendTeamTwoData();
      }
    } else if (eventType == "3x3") {
      if (selectedQuarterEvent == "Overtime") {
        dispatch(setMinutes(eventType3x3OvertimeTimer));
        dispatch(setSeconds(0));
        sendTeamOneData();
        sendTeamTwoData();
      } else {
        dispatch(setMinutes(eventType3x3DefaultTimer));
        dispatch(setSeconds(0));
        sendTeamOneData();
        sendTeamTwoData();
      }
    }

    stopTimer();

    dispatch(selectedQuarter(selectedQuarterEvent));
  };

  // Function to call event stats APIs when final period is reached
  const callFinalPeriodStats = async () => {
    if (!event_id || !token) {
      console.error("Missing event_id or token for stats API calls");
      return;
    }

    try {
      // Call team stats API
      const teamStatsUrl = `${process.env.REACT_APP_API_ROOT}/api/event/v2/event_stats/?event_id=${event_id}&level=team&force_recalc=true`;
      const teamStatsPromise = axios.get(teamStatsUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Call roster stats API
      const rosterStatsUrl = `${process.env.REACT_APP_API_ROOT}/api/event/v2/event_stats/?event_id=${event_id}&level=roster&force_recalc=true`;
      const rosterStatsPromise = axios.get(rosterStatsUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Execute both API calls in parallel
      const [teamStatsResponse, rosterStatsResponse] = await Promise.all([
        teamStatsPromise,
        rosterStatsPromise,
      ]);

      console.log("Team stats response:", teamStatsResponse.data);
      console.log("Roster stats response:", rosterStatsResponse.data);
    } catch (error) {
      console.error("Error calling final period stats APIs:", error);
    }
  };

  useEffect(() => {
    if (quarter === "Final") {
      dispatch(resetTimer());

      dispatch(matchStatusUpdate('liveEnd'));

      // Call stats APIs when final period is reached
      callFinalPeriodStats();
    }
  }, [dispatch, isRunning, quarter]);



  const [activeState, setActiveState] = useState(null);
  const [shortActiveState, setShortActiveState] = useState(null);

  useEffect(() => {
    if (made2PT === "active") {
      setActiveState("MADE_2_PT");
    } else if (made3PT === "active") {
      setActiveState("MADE_3_PT");
    } else if (made1PT === "active") {
      setActiveState("MADE_1_PT");
    } else if (miss1PT === "active") {
      setActiveState("MISS_1_PT");
    } else if (miss2PT === "active") {
      setActiveState("MISS_2_PT");
    } else if (miss3PT === "active") {
      setActiveState("MISS_3_PT");
    } else if (toActions === "active") {
      setActiveState("TO_PT");
    } else if (foulActions === "active") {
      setActiveState("FOUL_ACTIONS");
    }
  }, [made2PT, made3PT, made1PT, miss1PT, miss2PT, miss3PT, toPT, foulActions, shortFieldSelections, shortSelections]);

  useEffect(() => {

    if (shortSelectionsState) {
      setShortActiveState(shortSelectionsState)
    }
  }, [shortSelectionsState]);



  const handleBackClick = async () => {
    dispatch(resetScoreTemporaryData())
    dispatch(updatePostingDataReset())
    if (!assistSelections && (!shortFieldSelections && !shortSelections) && (made2PT === "active" || made1PT === "active" || made3PT === "active" || foulActions === "active" || toActions === "active")) {
      dispatch(playerAssistSelection())

    }

    else if (!reboundSelections && !assistSelections && (!shortFieldSelections && !shortSelections) && (miss1PT === "active" || miss2PT === "active" || miss3PT === "active")) {

      dispatch(playerAssistSelection())

    }

    else if (!assistSelections && (!shortFieldSelections && !shortSelections) && (assistSelections && playerSelectionsTeamOne) || (reboundSelections && playerSelectionsTeamOne) || (foulActionsSelections && playerSelectionsTeamOne) || (turnoverSelections && playerSelectionsTeamOne)) {

      dispatch(playerAssistSelection())
      handleSelectPoint(activeState)
    }
    else if (reboundSelections && !showShotChart && selectionAfterFieldGoalAttempt && activeState !== 'MISS_1_PT') {

      dispatch(playerAssistSelection())
      handleSelectPoint(activeState)
      setShortSelectionsState(shortActiveState)
      dispatch(playerSelectionTeamOne({
        actionPlayerId: actionPlayerId,
        shortSelections: true,
        playerSelectionsTeamOne: true,
        playerPointSelect: !false,
        shortFieldSelections: false,
        playerControlSelections: false,
        made2PT: activeState == 'MADE_2_PT' && 'active',
        made1PT: activeState == 'MADE_1_PT' && 'active',
        made3PT: activeState == 'MADE_3_PT' && 'active',
        miss1PT: activeState == 'MISS_1_PT' && 'active',
        miss2PT: activeState == 'MISS_2_PT' && 'active',
        miss3PT: activeState == 'MISS_3_PT' && 'active',
        foulActions: foulActions,
        toActions: toActions,
        point1: showShotChart ? point1 : null,
        point2: showShotChart ? point2 : null,
        point3: showShotChart ? point3 : null,
        pointMiss1: showShotChart ? pointMiss1 : null,
        pointMiss2: showShotChart ? pointMiss2 : null,
        pointMiss3: showShotChart ? pointMiss3 : null,
        assistPoint: showShotChart ? assistPoint : null,
        reboundBlockPoint: showShotChart ? reboundBlockPoint : null,
        turnoverPoint: showShotChart ? turnoverPoint : null,
        foulPoint: showShotChart ? foulPoint : null,
      }));
    }
    else if (!assistSelections && (!shortFieldSelections && !shortSelections) && (assistSelections && playerSelectionsTeamTwo) || (reboundSelections && playerSelectionsTeamTwo) || (foulActionsSelections && playerSelectionsTeamTwo) || (turnoverSelections && playerSelectionsTeamTwo)) {

      dispatch(playerAssistSelection())
      handleSelectPoint(activeState)
    }

    else if (!shortSelections && shortFieldSelections && playerSelectionsTeamOne) {

      dispatch(playerAssistSelection())
      handleSelectPoint(activeState)
    }

    else if (!shortSelections && shortFieldSelections && playerSelectionsTeamTwo) {

      dispatch(playerAssistSelection())
      handleSelectPoint(activeState)
    }

    else if (!shortFieldSelections && shortSelections && playerSelectionsTeamOne) {

      dispatch(playerAssistSelection())
      handleSelectPoint(activeState)
    }
    else if (!shortFieldSelections && shortSelections && playerSelectionsTeamTwo) {

      dispatch(playerAssistSelection())
      handleSelectPoint(activeState)
    }

    else if (shortFieldSelections && playerSelectionsTeamOne) {

      dispatch(playerAssistSelection())
      handleSelectPoint(activeState)
      // handlePlayerSelectionOne(actionPlayerId)
      dispatch(playerSelectionTeamOne({
        actionPlayerId: actionPlayerId,
        shortSelections: true,
        playerSelectionsTeamOne: true,
        playerPointSelect: !false,
        shortFieldSelections: false,
        playerControlSelections: false,
        made2PT: made2PT,
        made1PT: made1PT,
        made3PT: made3PT,
        miss1PT: miss1PT,
        miss2PT: miss2PT,
        miss3PT: miss3PT,
        foulActions: foulActions,
        toActions: toActions,
        point1: showShotChart ? point1 : null,
        point2: showShotChart ? point2 : null,
        point3: showShotChart ? point3 : null,
        pointMiss1: showShotChart ? pointMiss1 : null,
        pointMiss2: showShotChart ? pointMiss2 : null,
        pointMiss3: showShotChart ? pointMiss3 : null,
        assistPoint: showShotChart ? assistPoint : null,
        reboundBlockPoint: showShotChart ? reboundBlockPoint : null,
        turnoverPoint: showShotChart ? turnoverPoint : null,
        foulPoint: showShotChart ? foulPoint : null,
      }));
      setShortSelectionsState(shortActiveState)
    }
    else if (shortFieldSelections && playerSelectionsTeamTwo) {

      dispatch(playerAssistSelection())
      handleSelectPoint(activeState)

      dispatch(playerSelectionTeamTwo({
        actionPlayerId: actionPlayerId,
        shortSelections: true,
        playerSelectionsTeamTwo: true,
        playerPointSelect: !false,
        shortFieldSelections: false,
        playerControlSelections: false,
        made2PT: made2PT,
        made1PT: made1PT,
        made3PT: made3PT,
        miss1PT: miss1PT,
        miss2PT: miss2PT,
        miss3PT: miss3PT,
        foulActions: foulActions,
        toActions: toActions,
        point1: showShotChart ? point1 : null,
        point2: showShotChart ? point2 : null,
        point3: showShotChart ? point3 : null,
        pointMiss1: showShotChart ? pointMiss1 : null,
        pointMiss2: showShotChart ? pointMiss2 : null,
        pointMiss3: showShotChart ? pointMiss3 : null,
        assistPoint: showShotChart ? assistPoint : null,
        reboundBlockPoint: showShotChart ? reboundBlockPoint : null,
        turnoverPoint: showShotChart ? turnoverPoint : null,
        foulPoint: showShotChart ? foulPoint : null,
      }));
      setShortSelectionsState(shortActiveState)
    }

    else if (selectionAfterFieldGoalAttempt && showShotChart && assistSelections && playerSelectionsTeamOne) {

      dispatch(playerAssistSelection())
      handleSelectPoint(activeState)

      if (showShotChart) {

        dispatch(shortFieldSelection({
          shortFieldSelections: true,
          shortSelections: true,
          actionPlayerId: actionPlayerId,

          playerPointSelect: true,
          playerControlSelections: true,
          playerSelectionsTeamOne: false,
          playerSelectionsTeamTwo: false,

        }));

      } else {

        if (!shortSelections) {

          setShortSelectionsState(shortActiveState)

          if (activeState !== 'MADE_1_PT') {
            dispatch(playerSelectionTeamOne({
              actionPlayerId: actionPlayerId,
              shortSelections: true,
              playerSelectionsTeamOne: true,
              playerPointSelect: !false,
              shortFieldSelections: false,
              playerControlSelections: false,
              made2PT: activeState == 'MADE_2_PT' && 'active',
              made1PT: activeState == 'MADE_1_PT' && 'active',
              made3PT: activeState == 'MADE_3_PT' && 'active',
              miss1PT: activeState == 'MISS_1_PT' && 'active',
              miss2PT: activeState == 'MISS_2_PT' && 'active',
              miss3PT: activeState == 'MISS_3_PT' && 'active',
              foulActions: foulActions,
              toActions: toActions,
              point1: showShotChart ? point1 : null,
              point2: showShotChart ? point2 : null,
              point3: showShotChart ? point3 : null,
              pointMiss1: showShotChart ? pointMiss1 : null,
              pointMiss2: showShotChart ? pointMiss2 : null,
              pointMiss3: showShotChart ? pointMiss3 : null,
              assistPoint: showShotChart ? assistPoint : null,
              reboundBlockPoint: showShotChart ? reboundBlockPoint : null,
              turnoverPoint: showShotChart ? turnoverPoint : null,
              foulPoint: showShotChart ? foulPoint : null,
            }));
          }


        }


      }

    }

    else if (showShotChart && assistSelections && selectionAfterFieldGoalAttempt && playerSelectionsTeamTwo) {

      dispatch(playerAssistSelection())
      handleSelectPoint(activeState)

      if (showShotChart) {


        dispatch(shortFieldSelection({
          shortFieldSelections: true,
          shortSelections: true,
          actionPlayerId: actionPlayerId,

          playerPointSelect: true,
          playerControlSelections: true,
          playerSelectionsTeamOne: false,
          playerSelectionsTeamTwo: false,

        }));
      } else {
        setShortSelectionsState(shortActiveState)

        if (activeState !== 'MADE_1_PT') {
          dispatch(playerSelectionTeamTwo({
            actionPlayerId: actionPlayerId,
            shortSelections: true,
            playerSelectionsTeamTwo: true,
            playerPointSelect: !false,
            shortFieldSelections: false,
            playerControlSelections: false,
            made2PT: activeState == 'MADE_2_PT' && 'active',
            made1PT: activeState == 'MADE_1_PT' && 'active',
            made3PT: activeState == 'MADE_3_PT' && 'active',
            miss1PT: activeState == 'MISS_1_PT' && 'active',
            miss2PT: activeState == 'MISS_2_PT' && 'active',
            miss3PT: activeState == 'MISS_3_PT' && 'active',
            foulActions: foulActions,
            toActions: toActions,
            point1: showShotChart ? point1 : null,
            point2: showShotChart ? point2 : null,
            point3: showShotChart ? point3 : null,
            pointMiss1: showShotChart ? pointMiss1 : null,
            pointMiss2: showShotChart ? pointMiss2 : null,
            pointMiss3: showShotChart ? pointMiss3 : null,
            assistPoint: showShotChart ? assistPoint : null,
            reboundBlockPoint: showShotChart ? reboundBlockPoint : null,
            turnoverPoint: showShotChart ? turnoverPoint : null,
            foulPoint: showShotChart ? foulPoint : null,
          }));
        }


      }
    }
    else if (showShotChart && !shortSelections) {

      dispatch(playerAssistSelection())
      handleSelectPoint(activeState)
      if (activeState !== 'MISS_1_PT') {
        dispatch(shortFieldSelection({
          shortFieldSelections: true,
          shortSelections: true,
          actionPlayerId: actionPlayerId,

          playerPointSelect: true,
          playerControlSelections: true,
          playerSelectionsTeamOne: false,
          playerSelectionsTeamTwo: false,

        }));
      }

    }
    else if (shortSelections && showShotChart && selectionAfterFieldGoalAttempt) {

      dispatch(playerAssistSelection())
      handleSelectPoint(activeState)
      setShortSelectionsState(shortActiveState)
      if (activeState !== 'MADE_1_PT') {

        dispatch(playerSelectionTeamOne({
          actionPlayerId: actionPlayerId,
          shortSelections: true,
          playerSelectionsTeamOne: true,
          playerPointSelect: !false,
          shortFieldSelections: false,
          playerControlSelections: false,
          made2PT: made2PT,
          made1PT: made1PT,
          made3PT: made3PT,
          miss1PT: miss1PT,
          miss2PT: miss2PT,
          miss3PT: miss3PT,
          foulActions: foulActions,
          toActions: toActions,
          point1: showShotChart ? point1 : null,
          point2: showShotChart ? point2 : null,
          point3: showShotChart ? point3 : null,
          pointMiss1: showShotChart ? pointMiss1 : null,
          pointMiss2: showShotChart ? pointMiss2 : null,
          pointMiss3: showShotChart ? pointMiss3 : null,
          assistPoint: showShotChart ? assistPoint : null,
          reboundBlockPoint: showShotChart ? reboundBlockPoint : null,
          turnoverPoint: showShotChart ? turnoverPoint : null,
          foulPoint: showShotChart ? foulPoint : null,
        }));
      }




    } else if (showShotChart && !selectionAfterFieldGoalAttempt) {

      dispatch(playerAssistSelection())
      handleSelectPoint(activeState)

    } else if (!selectionAfterFieldGoalAttempt && !showShotChart && assistSelections && playerSelectionsTeamOne) {

      dispatch(playerAssistSelection())
      handleSelectPoint(activeState)
    } else if (!selectionAfterFieldGoalAttempt && !showShotChart && assistSelections && playerSelectionsTeamTwo) {

      dispatch(playerAssistSelection())
      handleSelectPoint(activeState)
    }

    else if (reboundSelections && !showShotChart && !selectionAfterFieldGoalAttempt
      && activeState == 'MISS_1_PT') {

      dispatch(playerAssistSelection())
      handleSelectPoint(activeState)
    }
    else if (reboundSelections && !showShotChart && selectionAfterFieldGoalAttempt
      && activeState == 'MISS_1_PT') {

      dispatch(playerAssistSelection())
      handleSelectPoint(activeState)
    }
    else if (assistSelections && !showShotChart && selectionAfterFieldGoalAttempt && playerSelectionsTeamOne

    ) {

      dispatch(playerAssistSelection())
      handleSelectPoint(activeState)

      if (activeState !== "MADE_1_PT") {
        setShortSelectionsState(shortActiveState)
        dispatch(playerSelectionTeamOne({
          actionPlayerId: actionPlayerId,
          shortSelections: true,
          playerSelectionsTeamOne: true,
          playerPointSelect: !false,
          shortFieldSelections: false,
          playerControlSelections: false,
          made2PT: activeState == 'MADE_2_PT' && 'active',
          made1PT: activeState == 'MADE_1_PT' && 'active',
          made3PT: activeState == 'MADE_3_PT' && 'active',
          miss1PT: activeState == 'MISS_1_PT' && 'active',
          miss2PT: activeState == 'MISS_2_PT' && 'active',
          miss3PT: activeState == 'MISS_3_PT' && 'active',
          foulActions: foulActions,
          toActions: toActions,
          point1: showShotChart ? point1 : null,
          point2: showShotChart ? point2 : null,
          point3: showShotChart ? point3 : null,
          pointMiss1: showShotChart ? pointMiss1 : null,
          pointMiss2: showShotChart ? pointMiss2 : null,
          pointMiss3: showShotChart ? pointMiss3 : null,
          assistPoint: showShotChart ? assistPoint : null,
          reboundBlockPoint: showShotChart ? reboundBlockPoint : null,
          turnoverPoint: showShotChart ? turnoverPoint : null,
          foulPoint: showShotChart ? foulPoint : null,
        }));
      }

    }
    else if (assistSelections && !showShotChart && selectionAfterFieldGoalAttempt && playerSelectionsTeamTwo

    ) {

      dispatch(playerAssistSelection())
      handleSelectPoint(activeState)

      if (activeState !== "MADE_1_PT") {
        setShortSelectionsState(shortActiveState)
        dispatch(playerSelectionTeamTwo({
          actionPlayerId: actionPlayerId,
          shortSelections: true,
          playerSelectionsTeamTwo: true,
          playerPointSelect: !false,
          shortFieldSelections: false,
          playerControlSelections: false,
          made2PT: activeState == 'MADE_2_PT' && 'active',
          made1PT: activeState == 'MADE_1_PT' && 'active',
          made3PT: activeState == 'MADE_3_PT' && 'active',
          miss1PT: activeState == 'MISS_1_PT' && 'active',
          miss2PT: activeState == 'MISS_2_PT' && 'active',
          miss3PT: activeState == 'MISS_3_PT' && 'active',
          foulActions: foulActions,
          toActions: toActions,
          point1: showShotChart ? point1 : null,
          point2: showShotChart ? point2 : null,
          point3: showShotChart ? point3 : null,
          pointMiss1: showShotChart ? pointMiss1 : null,
          pointMiss2: showShotChart ? pointMiss2 : null,
          pointMiss3: showShotChart ? pointMiss3 : null,
          assistPoint: showShotChart ? assistPoint : null,
          reboundBlockPoint: showShotChart ? reboundBlockPoint : null,
          turnoverPoint: showShotChart ? turnoverPoint : null,
          foulPoint: showShotChart ? foulPoint : null,
        }));
      }

    }



  };
  const sendTeamOneData = () => {
    const token = window.localStorage.getItem("token");
    dispatch(handleTeamOnePlayingPlayerTimeSend(matchData, event_team_a_id, event_id, event_group_id, token));
  };
  const sendTeamTwoData = () => {
    const token = window.localStorage.getItem("token");
    dispatch(handleTeamOnePlayingPlayerTimeSend2(matchData, event_team_b_id, event_id, event_group_id, token));
  };
  const sendTeamData = () => {
    const token = window.localStorage.getItem("token");
    dispatch(handleTeamPlayingPlayerTimeSend(matchData, event_team_a_id, event_team_b_id, event_id, event_group_id, token));

  };

  const sendTimeDataAuto = () => {
    dispatch(sendTimerData({
      shotClockValue,
      currentIsRunning: !isRunning,
      minutes,
      seconds,
      event_id,
      event_group_id,
      quarter,
      event_team_a_id,
      event_team_b_id
    }))

  }
  function findPlayerName(t_id, r_id) {
    let team, roster;
    if (matchData?.event_team_a_id == t_id) {
      team = matchData?.team_a_rosters;
    } else if (matchData?.event_team_b_id == t_id) {
      team = matchData?.team_b_rosters;
    } else {
      return "";
    }
    roster = team.find((player) => player.roster_id == r_id);
    return roster ? roster.short_name : "";
  }
  function findJerseyNumber(t_id, r_id) {
    let team, roster;
    if (matchData?.event_team_a_id == t_id) {
      team = matchData?.team_a_rosters;
    } else if (matchData?.event_team_b_id == t_id) {
      team = matchData?.team_b_rosters;
    } else {
      return "";
    }
    roster = team.find((player) => player?.roster_id == r_id);
    return roster ? roster.jersey_number : "";
  }
  const teamPointCount = (teamId) => {
    let totalPoints = 0;

    if (matchData?.game_data?.teamScore?.hasOwnProperty(teamId)) {
      totalPoints = matchData?.game_data?.teamScore[teamId].score;


    }

    return totalPoints;
  };
  const playerPersonalFoulCount = (teamId, rosterId) => {
    let personalFoulCount = 0;

    if (
      matchData?.game_data?.playerScore?.hasOwnProperty(teamId) &&
      matchData?.game_data?.playerScore[teamId]?.hasOwnProperty(rosterId)
    ) {
      const playerData = matchData?.game_data?.playerScore[teamId][rosterId];

      // Sum up personal fouls for the player
      personalFoulCount = playerData.personalFoul || 0;
    }

    return personalFoulCount;
  };
  const handleNavigatePlayerPage = () => {
    localStorage.setItem("player", "player");
    navigate(`/players/${matchData?.event_id}`);
  };
  const handleWarningMassage = () => {
    if (matchStatus == "Waiting to start") {
      toast.error("Please start the event first before using this button");
    } else if (matchStatus == "pause") {
      toast.error("Please Start the timer");
    } else if (quarter == "Final") {
      toast.error("Game Over");
    }
  };

  const [resetLoading, setResetLoading] = useState(false);
  const handleResetScore = async (id) => {
    setResetLoading(true);
    const data = new FormData();
    data.append("event_id", id);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_ROOT}/api/reset_score/`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `${token}`, // Include your authorization token here
          },
        }
      );
      if (response.status == 201) {
        toast.success("Reset Successfully");
        setResetLoading(false);
        setResetDataModal(false);
        window.location.reload();

      }
    } catch (error) {
      console.error("handleAddNewScore-Error:", error);
      // Handle error
    }
  };


  setTimeout(() => {
    setCustomLoading(false)
  }, 500)
  useEffect(() => {
    if (isTimeAuto == 30) {
      sendTeamData();

      setIsTimeAuto(0)
    }
  }, [isTimeAuto])
  useEffect(() => {
    if (isTimeAuto2 == 10) {
      sendTimeDataAuto();

      setIsTimeAuto2(0)
    }
  }, [isTimeAuto])
  const handleOverlay = () => {
    localStorage.removeItem("selectedGroupCodes");
    localStorage.removeItem("selectedEventsOptions");
    localStorage.removeItem("streamingOverlays");

    dispatch(handleNavigateStreamingOverlays(
      matchData.event_code,
      matchData.team_a_name,
      matchData.team_b_name,
      matchData.event_id,
      event_group_id,
      navigate // Pass the navigate function

    ));
  };




  useEffect(() => {
    const updateTimerStatus = async () => {
      if (minutes == 0 && seconds == 0) {
        dispatch(matchStatusUpdate('pause'));
        sendTeamOneData();
        sendTeamTwoData();
        try {
          const formData = new FormData();
          formData.append("score_timer", minutes * 60 + seconds);
          formData.append("event_id", matchData.event_id);
          formData.append("eg_id", matchData.event_group_id);
          formData.append("score_period", quarter);
          formData.append("timerStatus", "p");
          formData.append("shotclock", shotClockValue);
          formData.append("possession", possessionArrowTeamOne ? matchData?.event_team_a_id : matchData?.event_team_b_id);

          const response = await axios.post(`${baseApi}/set_timer/`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `${token}`,
            },
          });

          const game_status = response.data.game_status;
          dispatch(updateMatchTimeStatus({
            ...game_status,
          }));
        } catch (error) {
          console.error("Error:", error);
        }
      }
    };

    updateTimerStatus();
  }, [minutes, seconds]);
  const [shotClockFullScreen, setShotClockFullScreen] = useState(false);
  const handleShotClockFullScreen = () => {
    setShotClockFullScreen(!shotClockFullScreen);
  }



  const previousLogLength = useRef(0); // Ref for tracking previous log length

  useEffect(() => {
    let pointType = ['pointMissa3', 'pointMissa2', 'pointMissa1', 'point3', 'point2', 'point1', 'turnover', 'steal', 'defensiveRebound', 'block']

    let logLength = scoreTemporaryData?.length;
    let lastLog
    if (scoreTemporaryData[0]?.score_type == 'assist') {
      lastLog = scoreTemporaryData[1];
    } else if (scoreTemporaryData[1]?.score_type == 'defensiveRebound') {

      lastLog = scoreTemporaryData[1];
    } else if (scoreTemporaryData[1]?.score_type == 'block' && scoreTemporaryData.length == 3) {

      lastLog = scoreTemporaryData[2];
    } else if (scoreTemporaryData[1]?.score_type == 'steal') {
      lastLog = scoreTemporaryData[0];
    } else {
      lastLog = scoreTemporaryData[0];
    }

    //  team one b
    if (logLength > previousLogLength?.current) {
      if (
        event_team_a_id == lastLog?.t_id &&
        pointType.includes(lastLog?.score_type)
      ) {

        if (lastLog?.score_type == 'defensiveRebound') {

          dispatch(togglePossessionArrowTeamOne(true));
        } else {

          dispatch(togglePossessionArrowTeamTwo(true));
        }
      } else if (

        event_team_b_id == lastLog?.t_id &&
        pointType.includes(lastLog?.score_type)
      ) {

        if (lastLog?.score_type == 'defensiveRebound') {

          dispatch(togglePossessionArrowTeamTwo(true));
        } else {

          dispatch(togglePossessionArrowTeamOne(true));
        }
      }
    }

    previousLogLength.current = logLength; // Update the previous length
  }, [scoreTemporaryData]);



  const handleToggleTimeout = () => {

    if (!isRunning && timeout) {

      dispatch(toggleTimeout(false));
    } else {
      if (!timeoutCheck && isRunning) {

        startTimer(minutes, seconds);
        stopJumpBallClock()
        dispatch(sendTimerData({
          shotClockValue,
          possessionArrowTeamOne,
          possessionArrowTeamTwo,
          isRunning,
          minutes,
          seconds,
          event_id,
          event_group_id,
          quarter,
          event_team_a_id,
          event_team_b_id
        }))
      } else {

        handleStart(isRunning, true)
      }

      dispatch(toggleTimeout(isRunning ? false : true));
    }

  };


  useEffect(() => {
    if (foulPT && foulCalledSetting && foulCheck && shotClockCheck) {
      // stopTimer();
      setTimeout(() => {
        stopJumpBallClock()
        dispatch(sendTimerData({
          shotClockValue,
          possessionArrowTeamOne,
          possessionArrowTeamTwo,
          currentIsRunning: isRunning,
          minutes,
          seconds,
          event_id,
          event_group_id,
          quarter,
          event_team_a_id,
          event_team_b_id
        }))
      }, 100)
    } else if (foulPT && foulCalledSetting && !foulCheck && shotClockCheck) {
      startTimer(minutes, seconds);
      stopJumpBallClock()
      setTimeout(() => {
        stopJumpBallClock()
        dispatch(sendTimerData({
          shotClockValue,
          possessionArrowTeamOne,
          possessionArrowTeamTwo,
          currentIsRunning: isRunning,
          minutes,
          seconds,
          event_id,
          event_group_id,
          quarter,
          event_team_a_id,
          event_team_b_id
        }))
      }, 100)
    } else if (foulPT && foulCalledSetting) {
      // stopTimer();
      setTimeout(() => {
        stopJumpBallClock()
        dispatch(sendTimerData({
          shotClockValue,
          possessionArrowTeamOne,
          possessionArrowTeamTwo,
          currentIsRunning: isRunning,
          minutes,
          seconds,
          event_id,
          event_group_id,
          quarter,
          event_team_a_id,
          event_team_b_id
        }))
      }, 100)
    }

  }, [foulPT]);

  useEffect(() => {
    if ((quarter == "Q4" || quarter == "Overtime") && minutes == 0 && seconds == 0 && !confirmHardReload) {
      setConfirmHardReload(true)
    }
  }, [quarter, minutes, seconds])










  const [showSettings, setShowSettings] = useState(false);


  const handleModalClose = () => {
    setShowSettings(false);
  }

  const handleJumpBallModal = () => {
    const isTimer = (eventType5x5DefaultTimer * 60) != (minutes * 60 + seconds)
    // if(isTimer){

    // }
    if (!quarter) {
      toast.error("Please Select Period");
    } else if (quarter == 'NotStarted') {
      toast.error("Please Select Period");
    } else {
      if (isTimer) {
        if (quarter?.toLowerCase() !== 'q1') {
          toast.error("Period must be set to Q1 or H1")

        } else {
          setResetTimerModal(true)

        }

      } else {
        if (quarter?.toLowerCase() !== 'q1') {
          // setResetTimerModal(true)
          toast.error("Period must be set to Q1 or H1")

        } else {
          setOpenJumpBallModal(true)

        }



      }
    }
  }


  const handleResetTimer = () => {
    dispatch(setMinutes(eventType5x5DefaultTimer));
    dispatch(setSeconds(0));
    setResetTimerModal(false);
    setOpenJumpBallModal(true)

  }

  return (
    <>
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
      </Helmet>
      {
        (customLoading || loading) ? <Loading /> : <div>

          {
            matchData ? <DndProvider backend={HTML5Backend}>
              <div
                className={`bg-[#f2f2f2] w-full min-h-screen relative ${isPortrait && "overflow-hidden"
                  }`}
              >
                {expendPanel && (
                  <HeaderComponent
                    matchStatus={matchStatus}
                    setResetDataModal={setResetDataModal}
                    setExpendPanel={setExpendPanel}
                  />
                )}
                <div className="justify-center max-w-[932px] lg:max-w-[1512px] w-full px-1 lg:px-6 mx-auto flex min-h-screen relative">
                  <MatchComponent
                    matchStatus={matchStatus}
                    shotClockCheck={shotClockCheck}
                    foulPT={foulPT}
                    foul={foul}
                    missPT={missPT}
                    playerSelectionsTeamTwo={playerSelectionsTeamTwo}
                    playerSelectionsTeamOne={playerSelectionsTeamOne}
                    teamReboundSections={teamReboundSections}
                    actionPlayerId={actionPlayerId}
                    turnoverSelections={turnoverSelections}
                    foulActionsSelections={foulActionsSelections}
                    playerPointSelect={playerPointSelect}
                    teamOneColorSection={teamOneColorSection}
                    setTeamOneColorSection={setTeamOneColorSection}
                    teamOneColor={teamOneColor}
                    handleTeamOneColor={handleTeamOneColor}
                    teamOneName={teamOneName}
                    teamOnePlayingPlayer={teamOnePlayingPlayer}
                    handlePlayerSelectionOne={handlePlayerSelectionOne}
                    handlePlayerSelectionTwo={handlePlayerSelectionTwo}
                    // handlePlayerTeamOneDrop={handlePlayerTeamOneDrop}
                    findPlayerTeam={findPlayerTeam}
                    handleBackClick={handleBackClick}
                    teamPointCount={teamPointCount} // Example function to return the team score
                    teamTwoColorSection={teamTwoColorSection}
                    setTeamTwoColorSection={setTeamTwoColorSection}
                    handleTeamTwoColor={handleTeamTwoColor}
                    teamTwoName={teamTwoName}
                    teamTwoColor={teamTwoColor}
                    teamTwoPlayingPlayer={teamTwoPlayingPlayer}
                    // handlePlayerTeamTwoDrop={handlePlayerTeamTwoDrop}
                    setOpenStarterModal={setOpenStarterModal}
                    setTeamTab={setTeamTab}
                    matchData={matchData}
                    teamOneBench={teamOneBench}
                    teamTwoBench={teamTwoBench}
                    // message={message}
                    actionSteps={actionSteps}
                    dispatch={dispatch} // Redux dispatch function
                    playerPersonalFoulCount={playerPersonalFoulCount}
                    assistSelections={assistSelections}
                    shortSelections={shortSelections}
                    shortFieldSelections={shortFieldSelections}
                    event_team_a_id={event_team_a_id}
                    event_id={event_id}
                    event_group_id={event_group_id}
                    quarter={quarter}
                    minutes={minutes}
                    seconds={seconds}
                    token={token}
                    event_team_b_id={event_team_b_id}
                    // handlePlayerTeamTwoSub={handlePlayerTeamTwoSub}
                    made2PT={made2PT}
                    made1PT={made1PT}
                    made3PT={made3PT}
                    miss1PT={miss1PT}
                    miss2PT={miss2PT}
                    miss3PT={miss3PT}
                    teamAssistSections={teamAssistSections}
                    reboundSelections={reboundSelections}
                    toActions={toActions}
                    foulActions={foulActions}
                    cancelStep={cancelStep}
                    undoStep={undoStep}
                    isLoadingOne={isLoadingOne}
                    setIsLoadingOne={setIsLoadingOne}
                    isLoadingTwo={isLoadingTwo}
                    setIsLoadingTwo={setIsLoadingTwo}
                  />
                  <div className="w-[120px] lg:w-[273px] border border-b-0 px-1 lg:px-2 flex flex-col gap-1 md:gap-2 lg:gap-4 relative">
                    {playerPointSelect && (
                      <div className="max-w-[273px] w-full bg-[#f2f2f2eb] h-full absolute top-0 right-0 left-0 bottom-0 z-30">
                        {" "}
                      </div>
                    )}
                    {!expendPanel && (
                      <ExpendPanel
                        matchStatus={matchStatus}
                        setExpendPanel={setExpendPanel}
                      />
                    )}
                    <div className="max-w-[255px] w-full p-0 lg:p-4 border-[0px] lg:border-[1px] border-[#CCCCCC] rounded-md flex flex-col mt-[26px] lg:mt-5 ">
                      <Timer />
                      <div className="flex justify-between items-center gap-[6px] mt-[2px] lg:mt-4 lg:gap-4">
                        {quarterOptions?.length > 0 && (
                          <CustomDropdownControlPage
                            customStyle={`custom-drop-shadow text-[#4A4A4A] font-bebas text-[10px] lg:text-lg lg:max-w-[146px] max-w-[58px] p-[4.5px] lg:p-3 h-[30px] lg:h-14 rounded rounded cursor-pointer w-full flex justify-between items-center `}
                            customStyleDropdownList={`font-montserrat font-medium absolute bg-white rounded-md shadow-md w-full mt-3 p-1 lg:p-4 flex flex-col justify-center items-center `}
                            liCustomStyle={`cursor-pointer py-1 lg:py-2 text-[#4A4A4A] font-bebas text-[8px] lg:text-xl hover:font-semibold w-full`}
                            dropdownContainer="lg:max-w-[146px] max-w-[58px] w-full"
                            className=""
                            options={quarterOptions}
                            defaultValue={quarter}
                            onChange={handleQuarterChange}
                            selectedOption={selectedOption}
                            setSelectedOption={setSelectedOption}
                            showConfirmation={showConfirmation}
                            setShowConfirmation={setShowConfirmation}
                            setSelectedValue={setSelectedValue}
                            selectedValue={selectedValue}
                            shotClockValue={shotClockValue}
                            possessionArrowTeamOne={possessionArrowTeamOne}
                            possessionArrowTeamTwo={possessionArrowTeamTwo}
                            isRunning={isRunning}
                            minutes={minutes}
                            seconds={seconds}
                            event_id={event_id}
                            event_group_id={event_group_id}
                            quarter={quarter}
                            event_team_a_id={event_team_a_id}
                            event_team_b_id={event_team_b_id}
                          />
                        )}
                        <button
                          disabled={quarter == "Final"}
                          onClick={() => handleStart(isRunning, true)}
                          className="w-10 lg:w-14 h-[28px] lg:h-14 rounded flex justify-center items-center cursor-pointer"
                          style={{
                            boxShadow:
                              "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
                          }}
                        >
                          <IconCollection
                            customClass="lg:max-w-6 max-w-[10px] w-full lg:h-6 h-[10px]"
                            name={isRunning ? "pause-icon" : "play-icon"}
                          />
                        </button>
                      </div>
                    </div>
                    <button
                      disabled={
                        matchStatus == "liveEnd" || matchStatus == "Waiting to start"
                      }
                      onClick={() => handleToggleTimeout()}
                      className={`max-w-[255px] h-[22.47px] lg:h-[60px] rounded lg:rounded-md custom-drop-shadow  font-bebas text-[12px] lg:text-2xl flex justify-center items-center cursor-pointer  ${!timeout
                        ? "bg-[#DB5F66] text-white"
                        : "text-[#DB5F66] bg-white"
                        }`}
                    >
                      Timeout

                    </button>
                    {
                      shotClockCheck && (
                        <ShotClock
                          shotClockFullScreen={shotClockFullScreen}
                          setShotClockFullScreen={setShotClockFullScreen} handleShotClockFullScreen={handleShotClockFullScreen}

                        />
                      )
                    }
                    <div className="flex justify-center items-center gap-1">
                      <button
                        disabled={matchStatus == "liveEnd"}
                        onClick={() => handleNavigatePlayerPage()}
                        className="custom-drop-shadow cursor-pointer h-4 lg:h-8 custom-drop-shadow rounded-[2px] lg:rounded text-[#7D7D7D] font-bebas text-[6px] lg:text-sm flex justify-center items-center flex-1"
                      >
                        Players
                      </button>
                      <button
                        disabled={matchStatus == "liveEnd"}
                        onClick={handleOverlay}
                        className="custom-drop-shadow cursor-pointer h-4 lg:h-8 custom-drop-shadow rounded-[2px] lg:rounded text-[#7D7D7D] font-bebas text-[6px] lg:text-sm flex justify-center items-center flex-1"
                      >
                        Streaming
                      </button>
                      <button
                        disabled={matchStatus == "liveEnd" || isLoadingOne || isLoadingTwo}
                        onClick={() => [dispatch(setOpenStarterModal(true)), setTeamTab("team1")]}
                        className="custom-drop-shadow cursor-pointer h-4 lg:h-8 custom-drop-shadow rounded-[2px] lg:rounded text-[#7D7D7D] font-bebas text-[6px] lg:text-sm flex justify-center items-center flex-1"
                      >
                        Starter
                      </button>
{console.log(`hello_world_001`,matchStatus,teamTwoPlayingPlayer.length, teamOnePlayingPlayer.length, jumpBallTeamAPlayerRosterId, jumpBallTeamBPlayerRosterId)}
                      <button
                        disabled={
                          matchStatus == "liveEnd" ||
                          teamTwoPlayingPlayer.length < requiredPlayers ||
                          teamOnePlayingPlayer.length < requiredPlayers ||
                          (jumpBallTeamAPlayerRosterId && jumpBallTeamBPlayerRosterId)
                        }
                        onClick={() => handleJumpBallModal()}
                        className="custom-drop-shadow cursor-pointer h-4 lg:h-8 custom-drop-shadow rounded-[2px] lg:rounded text-[#7D7D7D] font-bebas text-[6px] lg:text-sm flex justify-center items-center flex-1"
                      >
                        jump ball
                      </button>

                    </div>
                    <div className="w-full  border-[#CCCCCC] border-b-0 rounded-b-none border-[1px]  rounded-md p-[4px] lg:p-[6px]">
                      <div className="flex py-1 lg:py-3 justify-center items-center gap-[2px] lg:gap-2">
                        <p className="text-[#4A4A4A] font-bebas text-[10px] lg:text-xl text-center">
                          Event Logs
                        </p>
                        <div className="bg-[#4A4A4A] h-2 lg:h-[16px] w-[1px] lg:w-[2px]"></div>
                        <p className="text-[#4A4A4A] font-bebas text-[10px] lg:text-xl text-center">
                          {matchData?.event_code}
                        </p>
                        {game_data && (
                          <Link to="/game-logs" className="pl-1 lg:pl-4">
                            <IconCollection
                              customClass="lg:max-w-6 mt-[-4px] max-w-[10px] w-full lg:h-6 h-[10px]"
                              name="log-icon"
                            />
                          </Link>
                        )}
                      </div>
                      <div className="flex flex-col gap-2 mt-2 lg:mt-[22px] min-h-[126px] max-h-[126px] lg:min-h-[440px] lg:max-h-[440px] overflow-y-auto  pr-[2px] lg:pr-[6px] control-page-scroll-bar">
                        {filteredPostingData && (
                          <>
                            {filteredPostingData?.length > 0 &&
                              filteredPostingData
                                ?.sort((a, b) => a.seq - b.seq)
                                .filter(
                                  (log) => log?.score_period?.trim() !== "NotStarted"
                                )
                                .map((log, index) => (
                                  <div
                                    key={index}
                                    className={`max-w-[225px] opacity-50 p-1 lg:p-3 w-full  flex relative items-start border-[1px] border-l-[4px] rounded-sm
                         `}
                                    style={{
                                      borderColor:
                                        log.t_id == matchData.event_team_a_id
                                          ? teamOneColor
                                          : teamTwoColor,
                                    }}
                                  >

                                    <GameLogEntry
                                      key={index}
                                      log={log}
                                      matchData={matchData}
                                      teamOneColor={teamOneColor}
                                      teamTwoColor={teamTwoColor}
                                      teamOneName={teamOneName}
                                      teamTwoName={teamTwoName}
                                      findJerseyNumber={findJerseyNumber}
                                      findPlayerName={findPlayerName}
                                    />
                                    <LogStatusActions
                                      status={log.status}
                                      unique_id={log.unique_id}
                                      handleAddNewScoreReBulk={handleReBulkScore}
                                      deletePostingDataFunction={deletePostingDataFunction}
                                    />
                                    <div className="flex gap-1 lg:gap-2 max-w-10 items-center top-[-4px] lg:top-auto justify-between absolute right-1">
                                      {log?.star && (
                                        <div>
                                          <IconCollection
                                            customClass="lg:max-w-4 max-w-[8px] w-full lg:h-4 h-[8px]"
                                            name="star-color-icon"
                                          />
                                        </div>
                                      )}
                                      {log.type && (
                                        <button
                                          onClick={() => [
                                            setScoreDeleteModal(true),
                                            setScoreId({
                                              type: log.type,
                                              data_id: log.data_id,
                                              eg_id: log.eg_id,
                                              event_id: log.event_id,
                                              score_timer: log.score_timer,
                                              score_period: log.score_period,
                                            }),
                                          ]}
                                        >
                                          <IconCollection
                                            name="delete-icon"
                                            customClass="lg:max-w-4 max-w-[8px] w-full lg:h-4 h-[8px]"
                                          />
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                ))}
                          </>
                        )}
                        <GameLogComponent
                          game_data={game_data}
                          game_log={game_log}
                          matchData={matchData}
                          teamOneColor={teamOneColor}
                          teamTwoColor={teamTwoColor}
                          teamOneName={teamOneName}
                          teamTwoName={teamTwoName}
                          findJerseyNumber={findJerseyNumber}
                          findPlayerName={findPlayerName}
                          setScoreDeleteModal={setScoreDeleteModal}
                          setScoreId={setScoreId}
                        />

                      </div>
                    </div>
                  </div>
                  {shortSelections && (
                    <ShortSelections
                      made2PT={made2PT}
                      miss2PT={miss2PT}
                      shortSelectionsState={shortSelectionsState}
                      setShortSelectionsState={setShortSelectionsState}
                      rangeValue={rangeValue}
                      handleChange={handleChange}
                      actionPlayerId={actionPlayerId}
                    />
                  )}

                  {shortFieldSelections && (
                    <ShortFieldSelections
                      actionPlayerId={actionPlayerId}
                      handleFieldScore={handleFieldScore}
                      handleFieldLocation={handleFieldLocation}
                      basketballFieldImg={basketballFieldImg}  // Assuming this image is imported or available
                    />
                  )}

                  {!shortFieldSelections && playerControlSelections && !assistSelections && (
                    <PlayerControlSelections
                      matchStatus={matchStatus}
                      quarter={quarter}
                      made1PT={made1PT}
                      made2PT={made2PT}
                      made3PT={made3PT}
                      miss1PT={miss1PT}
                      miss2PT={miss2PT}
                      miss3PT={miss3PT}
                      foulActions={foulActions}
                      toActions={toActions}
                      handleSelectPoint={handleSelectPoint}
                      handleWarningMassage={handleWarningMassage}
                      setStarState={setStarState}
                      starState={starState}
                      star_logo={star_logo}
                      setMiss1PTActive={setMiss1PTActive}
                    />
                  )}
                  {reboundSelections && (
                    <ReboundSelections
                      handleReboundPart={handleReboundPart}
                      teamReboundSections={teamReboundSections}
                      actionPlayerId={actionPlayerId}
                      miss1PTActive={miss1PTActive}
                      starState={starState}
                      setStarState={setStarState}
                      star_logo={star_logo}  // Assuming `star_logo` is an imported asset
                      hideBlock={hideBlock}
                      setHideBlock={setHideBlock}
                      scoreTemporaryData={scoreTemporaryData}
                      teamOneId={event_team_a_id}
                      teamTwoId={event_team_b_id}
                      game_log={game_log}
                      sendTimerData={() => dispatch(sendTimerData({
                        shotClockValue,
                        possessionArrowTeamOne,
                        possessionArrowTeamTwo,
                        isRunning,
                        minutes,
                        seconds,
                        event_id,
                        event_group_id,
                        quarter,
                        event_team_a_id,
                        event_team_b_id
                      }))}
                    />
                  )}
                  {assistSelections && (
                    <AssistSelections
                      handleAssistPart={handleAssistPart}
                      teamAssistSections={teamAssistSections}
                      actionPlayerId={actionPlayerId}
                      starState={starState}
                      setStarState={setStarState}
                      star_logo={star_logo}  // Assuming `star_logo` is an imported asset
                    />
                  )}
                  {turnoverSelections && (
                    <TurnoverSelections
                      handleTurnoverPart={handleTurnoverPart}
                      teamTurnoverSections={teamTurnoverSections}
                      starState={starState}
                      setStarState={setStarState}
                      star_logo={star_logo}  // Assuming `star_logo` is an imported asset
                    />
                  )}
                  {foulActionsSelections && (
                    <FoulActionsSelections
                      handleFoulPart={handleFoulPart}
                      setTeamFoulSections={setTeamFoulSections}
                      teamFoulSections={teamFoulSections}
                      actionPlayerId={actionPlayerId}
                      starState={starState}
                      setStarState={setStarState}
                      star_logo={star_logo}  // Assuming `star_logo` is an imported asset
                    />
                  )}
                </div>
                <Starter
                  teamTab={teamTab}
                  setTeamTab={setTeamTab}
                  openStarterModal={openStarterModal}
                  // setOpenStarterModal={setOpenStarterModal}
                  matchData={matchData}
                  playersReducer={playersReducer}
                  setTeamOnePlayersPlaying={setTeamOnePlayersPlaying}
                  setTeamTwoPlayersPlaying={setTeamTwoPlayersPlaying}
                  teamTwoPlayersPlaying={teamTwoPlayersPlaying}
                  teamOnePlayersPlaying={teamOnePlayersPlaying}
                  minutes={minutes}
                  seconds={seconds}
                  quarter={quarter}
                  playerPersonalFoulCount={playerPersonalFoulCount}
                  actionPlayerId={actionPlayerId}
                  event_team_a_id={event_team_a_id}
                  event_team_b_id={event_team_b_id}
                  isLoadingOne={isLoadingOne}

                  isLoadingTwo={isLoadingTwo}
                  eventType={eventType}

                />
                {resetDataModal && (
                  <ResetDataModal
                    setResetDataModal={setResetDataModal}
                    resetDataModal={resetDataModal}
                    handleResetScore={handleResetScore}
                    loading={resetLoading}
                    matchData={matchData}  // Assuming matchData is defined in the parent component
                  />
                )}
                {
                  scoreDeleteModal && (
                    <ScoreDeleteModal
                      scoreDeleteLoading={scoreDeleteLoading}
                      setScoreDeleteModal={setScoreDeleteModal}
                      handleDelScore={() =>
                        handleDelScore(scoreId.type, scoreId.data_id, scoreId.eg_id, scoreId.event_id)
                      }
                    />
                  )
                }
                {isPortrait && <IsPortraitModal />}
                {openJumpBallModal &&
                  <JumpBallModal
                    quarter={quarter}
                    matchData={matchData}
                    openJumpBallModal={openJumpBallModal}
                    setOpenJumpBallModal={setOpenJumpBallModal}
                    teamOnePlayersPlaying={teamOnePlayersPlaying}
                    teamTwoPlayersPlaying={teamTwoPlayersPlaying}
                    teamOneColor={teamOneColor}
                    teamTwoColor={teamTwoColor}
                    shotClockValue={shotClockValue}
                    teamOneName={teamOneName}
                    teamTwoName={teamTwoName}
                    teamOneId={event_team_a_id}
                    teamTwoId={event_team_b_id}
                    teamOneJumpBallPlayer={teamOneJumpBallPlayer}
                    teamTwoJumpBallPlayer={teamTwoJumpBallPlayer}
                    event_id={event_id}
                    event_group_id={event_group_id}
                    event_team_a_id={event_team_a_id}
                    event_team_b_id={event_team_b_id}
                    possessionArrowTeamOne={possessionArrowTeamOne}
                    possessionArrowTeamTwo={possessionArrowTeamTwo}
                    isRunning={isRunning}
                  />}
                {resetTimerModal && (
                  <ResetTimerModal
                    isOpen={resetTimerModal}
                    onClose={() => setResetTimerModal(false)}
                    onConfirm={() => handleResetTimer()}
                    message="Reset the timer?"
                  // loading={resetLoading}
                  />
                )}

                {
                  confirmHardReload && (
                    <ConfirmHardReload
                      setConfirmHardReload={setConfirmHardReload}
                      confirmHardReload={confirmHardReload}
                      handleHardReload={handleHardReload}
                    />
                  )
                }
                {
                  process.env.REACT_APP_SERVER === "development" && (
                    <button onClick={() => [
                      setShowSettings(true),
                      localStorage.setItem("event_id", event_id)
                    ]} className="fixed bottom-4 right-4">
                      <IoSettingsOutline className="text-5xl" />
                    </button>
                  )
                }

                {
                  showSettings && (
                    <div className={`fixed top-0 z-[60] left-0 right-0 bottom-0 bg-black bg-opacity-35 min-h-screen flex justify-center items-center w-full`}>
                      <div className='max-w-[350px] md:max-w-[900px] h-[90vh] relative w-full bg-white rounded-lg border-none py-2 md:py-10 overflow-y-auto overflow-x-hidden' >
                        <div onClick={() => handleModalClose()} className='absolute right-4 top-4 cursor-pointer'>
                          <IconCollection customClass='md:w-6 md:h-6 w-[10px] h-[10px]' name="close" />
                        </div>
                        <br />
                        <Settings />
                      </div>
                    </div>
                  )
                }

              </div>
            </DndProvider> : <ErrorPage />
          }
        </div>
      }
    </>

  );
};

export default ControlPage;
